"use strict";

window.babiiniAssetUrl = window.babiiniAssetUrl || function (path) {
  return (window.BABIINI_ASSET_URLS && window.BABIINI_ASSET_URLS[path]) || ("/assets/" + path);
};

/* js/shopify-effects.js */
(() => {
  "use strict";

  const motionPreference = window.matchMedia("(prefers-reduced-motion: reduce)");

  function setupAnnouncementMarquee() {
    document.querySelectorAll("[data-announcement-track]").forEach((track) => {
      if (track.dataset.announcementReady === "true") return;

      const sourceNodes = Array.from(track.children);
      const sourceText = Array.from(new Set(sourceNodes.map((node) => node.textContent.trim()).filter(Boolean)));
      if (!sourceNodes.length || !sourceText.length) return;

      const repeatCount = Math.max(1, Number.parseInt(track.dataset.announcementRepeats || "3", 10));
      const parent = track.parentElement;
      if (parent && !parent.hasAttribute("aria-label")) parent.setAttribute("aria-label", sourceText.join(". "));

      const buildGroup = () => {
        const group = document.createElement("span");
        group.className = "announcement-marquee__group";

        for (let repeat = 0; repeat < repeatCount; repeat += 1) {
          sourceNodes.forEach((sourceNode) => {
            const clone = sourceNode.cloneNode(true);
            clone.classList.add("announcement-marquee__item");
            clone.removeAttribute("id");
            clone.querySelectorAll("[id]").forEach((node) => node.removeAttribute("id"));
            group.append(clone);
          });
        }

        return group;
      };

      track.replaceChildren(buildGroup(), buildGroup());
      track.classList.add("announcement-marquee__track", "is-marquee-ready");
      track.setAttribute("aria-hidden", "true");
      track.dataset.announcementReady = "true";
    });
  }

  function enhanceBelowFoldImages() {
    const main = document.querySelector("main");
    const firstSection = main?.querySelector(":scope > section");
    const images = document.querySelectorAll("main img, footer img, [data-below-fold-image]");
    const lazyImages = [];

    images.forEach((image) => {
      if (image.hasAttribute("data-priority-image") || image.getAttribute("loading") === "eager") return;
      if (image.closest("header, [data-menu], [data-cart-overlay]")) return;
      if (firstSection && image.closest("section") === firstSection && !image.hasAttribute("data-below-fold-image")) return;

      if (!image.hasAttribute("loading")) image.setAttribute("loading", "lazy");
      if (!image.hasAttribute("decoding")) image.setAttribute("decoding", "async");
      lazyImages.push(image);

      const markLoaded = () => image.classList.add("is-loaded");
      if (image.complete) markLoaded();
      else image.addEventListener("load", markLoaded, { once: true });
    });

    if (!lazyImages.length || !("IntersectionObserver" in window)) return;
    const preloadObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute("loading", "eager");
          preloadObserver.unobserve(entry.target);
        });
      },
      { rootMargin: "1600px 0px", threshold: 0 },
    );
    lazyImages.forEach((image) => preloadObserver.observe(image));
  }

  function setupScrollReveals() {
    const revealElements = Array.from(document.querySelectorAll("[data-reveal]"));
    if (!revealElements.length) return;

    const revealAll = () => revealElements.forEach((element) => element.classList.add("is-visible"));
    revealElements.forEach((element) => {
      const delay = Number.parseInt(element.getAttribute("data-reveal-delay") || "0", 10);
      if (Number.isFinite(delay) && delay > 0) element.style.setProperty("--reveal-delay", `${delay}ms`);
    });

    if (motionPreference.matches || !("IntersectionObserver" in window)) {
      document.documentElement.classList.add("reduced-motion");
      revealAll();
      return;
    }

    document.documentElement.classList.add("reveal-ready");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 },
    );
    revealElements.forEach((element) => observer.observe(element));
  }

  function initializeEffects() {
    if (document.documentElement.dataset.shopifyEffectsReady === "true") return;
    document.documentElement.dataset.shopifyEffectsReady = "true";
    document.documentElement.classList.add("has-js");
    setupAnnouncementMarquee();
    enhanceBelowFoldImages();
    setupScrollReveals();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initializeEffects, { once: true });
  else initializeEffects();
})();


/* js/commerce-cards.js */
(() => {
  "use strict";

  const shopifyStorefront = Boolean(window.Shopify || window.ShopifyAnalytics);
  const productConfig = {
    carrier: {
      staticPath: "/the-trendi-carrier.html",
      shopifyPath: "/products/the-trendi-carrier",
      defaultVariantId: 45403572895813,
      colorAliases: {
        clay: "Dessert Brown",
        "desert brown": "Dessert Brown",
        "dessert brown": "Dessert Brown",
        "soft blue": "Maya Blue",
        "maya blue": "Maya Blue",
        azul: "Maya Blue",
        cream: "Houndstooth",
        crema: "Houndstooth",
        houndstooth: "Houndstooth",
      },
      variants: {
        "Dessert Brown": 45403572830277,
        "Maya Blue": 45403572863045,
        Houndstooth: 45403572895813,
      },
    },
    wrap: {
      staticPath: "/the-original-wrap.html",
      shopifyPath: "/products/the-original-wrap",
      defaultVariantId: 45110359851077,
      colorAliases: {
        lime: "Pistachio Green",
        lima: "Pistachio Green",
        "pistachio green": "Pistachio Green",
        charcoal: "Midnight Black",
        "midnight black": "Midnight Black",
        gray: "Pebble Gray",
        "pebble gray": "Pebble Gray",
        white: "White Bubble",
        "white bubble": "White Bubble",
      },
      variants: {
        "Pistachio Green": 45110359851077,
        "Midnight Black": 45403573452869,
        "Pebble Gray": 45403573485637,
        "White Bubble": 45403573518405,
      },
    },
    pack: {
      staticPath: "/comprar.html",
      shopifyPath: "/products/pack-newborn",
      defaultVariantId: 45403560280133,
      colorAliases: {},
      variants: {},
    },
  };
  const shopifyProducts = window.BABIINI_SHOPIFY_PRODUCTS || {};
  if (shopifyStorefront) {
    Object.entries(productConfig).forEach(([key, config]) => {
      const liveProduct = shopifyProducts[key];
      if (!liveProduct) return;
      if (liveProduct.variants && Object.keys(liveProduct.variants).length) {
        config.variants = Object.fromEntries(
          Object.entries(liveProduct.variants).filter(([label]) => label.toLocaleLowerCase("es") !== "fancy cow"),
        );
      }
      if (liveProduct.availableVariants) {
        liveProduct.availableVariants = Object.fromEntries(
          Object.entries(liveProduct.availableVariants).filter(([label]) => label.toLocaleLowerCase("es") !== "fancy cow"),
        );
      }
      config.defaultVariantId =
        (key === "carrier" ? config.variants.Houndstooth : liveProduct.defaultVariantId) ||
        Object.values(config.variants)[0] ||
        config.defaultVariantId;
    });
  }
  const bundleDiscountCode = "PACKNEWBORN25";
  const liveVariantId = (key, label, fallbackId) =>
    productConfig[key]?.variants?.[label] || fallbackId;
  const liveVariantAvailable = (key, ...labels) => {
    const availability = shopifyProducts[key]?.availableVariants;
    if (!availability || !Object.keys(availability).length) return true;
    const liveLabel = labels.find((label) =>
      Object.prototype.hasOwnProperty.call(availability, label)
    );
    return liveLabel ? Boolean(availability[liveLabel]) : true;
  };
  const bundleConfig = {
    carrier: {
      title: "The Trendi Carrier",
      price: shopifyProducts.carrier?.price || 149.99,
      variants: [
        { id: liveVariantId("carrier", "Desert Brown", liveVariantId("carrier", "Dessert Brown", 45403572830277)), label: "Desert Brown", image: "home/carrier-clay.webp", available: liveVariantAvailable("carrier", "Desert Brown", "Dessert Brown") },
        { id: liveVariantId("carrier", "Maya Blue", 45403572863045), label: "Maya Blue", image: "home/carrier-blue.webp", available: liveVariantAvailable("carrier", "Maya Blue") },
        { id: liveVariantId("carrier", "Houndstooth", 45403572895813), label: "Houndstooth", image: "meta-ads/products/carrier-houndstooth-figma.webp", available: liveVariantAvailable("carrier", "Houndstooth") },
      ],
    },
    wrap: {
      title: "The Original Wrap",
      price: shopifyProducts.wrap?.price || 48.6,
      variants: [
        { id: liveVariantId("wrap", "Pistachio Green", 45110359851077), label: "Pistachio Green", image: "home/wrap-lime.webp", available: liveVariantAvailable("wrap", "Pistachio Green") },
        { id: liveVariantId("wrap", "Midnight Black", 45403573452869), label: "Midnight Black", image: "home/wrap-charcoal.webp", available: liveVariantAvailable("wrap", "Midnight Black") },
        { id: liveVariantId("wrap", "Pebble Gray", 45403573485637), label: "Pebble Gray", image: "home/wrap-gray.webp", available: liveVariantAvailable("wrap", "Pebble Gray") },
        { id: liveVariantId("wrap", "White Bubble", 45403573518405), label: "White Bubble", image: "home/wrap-white.webp", available: liveVariantAvailable("wrap", "White Bubble") },
      ],
    },
  };
  const bundleDiscountedPrice = (price) => {
    const cents = Math.round(price * 100);
    return (cents - Math.floor(cents * 0.25)) / 100;
  };
  const bundleRegularPrice = bundleConfig.carrier.price + bundleConfig.wrap.price;
  const bundlePrice =
    bundleDiscountedPrice(bundleConfig.carrier.price) +
    bundleDiscountedPrice(bundleConfig.wrap.price);
  const bundleSavings = bundleRegularPrice - bundlePrice;

  const productKeyFor = (button) => {
    const key = button.dataset.cartAdd?.toLowerCase() || "";
    if (key.includes("pack")) return "pack";
    if (key.includes("wrap")) return "wrap";
    return "carrier";
  };

  const normalizedColorFor = (key, button) => {
    const requestedColor = button.dataset.cartColor?.trim().toLowerCase() || "";
    return productConfig[key]?.colorAliases[requestedColor] || "";
  };

  const variantIdFor = (key, button) => {
    const config = productConfig[key];
    if (!config) return null;
    const color = normalizedColorFor(key, button);
    const liveColor = color === "Dessert Brown" ? "Desert Brown" : color;
    return config.variants[color] || config.variants[liveColor] || config.defaultVariantId;
  };

  const productPathFor = (key, button) => {
    const config = productConfig[key];
    const basePath = shopifyStorefront ? config.shopifyPath : config.staticPath;
    const color = normalizedColorFor(key, button);
    return color ? `${basePath}?color=${encodeURIComponent(color)}` : basePath;
  };

  const wrapProductVisual = (card, productPath) => {
    const existingLink = [...card.children].find((child) => child.matches("a.product-card__visual, a.shop-card__visual"));
    if (existingLink instanceof HTMLAnchorElement) {
      existingLink.href = productPath;
      return existingLink;
    }
    const visual = [...card.children].find((child) => child.matches("img, picture, figure"));
    if (!visual || visual.parentElement?.matches("a")) return null;
    const link = document.createElement("a");
    link.className = card.classList.contains("product-card") ? "product-card__visual" : "shop-card__visual";
    link.href = productPath;
    link.setAttribute("aria-label", `Ver ${card.querySelector("h3, h4")?.textContent?.trim() || "producto"}`);
    visual.before(link);
    link.append(visual);
    return link;
  };

  const setupCardNavigation = (card, productLink) => {
    if (!(productLink instanceof HTMLAnchorElement) || card.dataset.productLinkReady === "true") return;

    card.dataset.productLinkReady = "true";
    card.classList.add("is-product-link");
    card.addEventListener("click", (event) => {
      if (event.defaultPrevented || !(event.target instanceof Element)) return;
      if (event.target.closest("a, button, input, select, textarea, [role='button']")) return;
      window.location.assign(productLink.href);
    });
  };

  const buildBuyNowButton = (addButton) => {
    const buyButton = document.createElement("button");
    buyButton.className = "button button--buy-now";
    buyButton.type = "button";
    buyButton.textContent = "Comprar ahora";
    buyButton.dataset.cartBuyNow = productKeyFor(addButton);
    return buyButton;
  };

  const setLoadingState = (button, loading, message = "") => {
    if (loading) {
      button.dataset.cartOriginalLabel = button.textContent;
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.textContent = message || "Procesando…";
      return;
    }
    button.disabled = false;
    button.removeAttribute("aria-busy");
    button.textContent = button.dataset.cartOriginalLabel || button.textContent;
    delete button.dataset.cartOriginalLabel;
  };

  const assetUrl = (path) => {
    if (typeof window.babiiniAssetUrl === "function") return window.babiiniAssetUrl(path);
    return `/assets/${path}`;
  };

  const updateLiveProduct = (key, product) => {
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    if (!variants.length || !productConfig[key]) return;

    const variantIds = Object.fromEntries(variants.map((variant) => [variant.title, variant.id]));
    const liveProduct = shopifyProducts[key] || {};
    const serverAvailability = liveProduct.availableVariants || {};
    const availableVariants = Object.fromEntries(variants.map((variant) => {
      const ajaxAvailable = variant.available !== false;
      const hasServerAvailability = Object.prototype.hasOwnProperty.call(serverAvailability, variant.title);
      return [
        variant.title,
        hasServerAvailability ? Boolean(serverAvailability[variant.title]) && ajaxAvailable : ajaxAvailable,
      ];
    }));
    const defaultVariant = variants.find((variant) => availableVariants[variant.title]) || variants[0];
    liveProduct.variants = variantIds;
    liveProduct.availableVariants = availableVariants;
    liveProduct.defaultVariantId = defaultVariant?.id || liveProduct.defaultVariantId;
    shopifyProducts[key] = liveProduct;
    productConfig[key].variants = variantIds;
    productConfig[key].defaultVariantId = liveProduct.defaultVariantId;
  };

  const setupBundleConfigurator = () => {
    const openers = Array.from(document.querySelectorAll('[data-cart-add*="pack"]'));
    if (!openers.length) return null;

    const normalizedVariantLabel = (value) => String(value || "")
      .trim()
      .toLocaleLowerCase("es")
      .replace(/dessert brown/g, "desert brown")
      .replace(/\s+/g, " ");

    const choicesMarkup = (key) => {
      const variants = bundleConfig[key].variants;
      const firstAvailable = variants.find((variant) => variant.available);
      const unavailablePlaceholder = firstAvailable
        ? ""
        : '<option value="" selected>Sin diseños disponibles</option>';
      return unavailablePlaceholder + variants
        .map((variant) => {
          const selected = firstAvailable?.id === variant.id ? " selected" : "";
          const disabled = variant.available ? "" : " disabled";
          const suffix = variant.available ? "" : " — Agotado";
          return `<option value="${variant.id}"${selected}${disabled}>${variant.label}${suffix}</option>`;
        })
        .join("");
    };
    const dialog = document.createElement("div");
    dialog.className = "bundle-modal";
    dialog.id = "pack-newborn-configurator";
    dialog.hidden = true;
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    dialog.setAttribute("aria-hidden", "true");
    dialog.setAttribute("aria-labelledby", "pack-newborn-configurator-title");
    dialog.innerHTML = `
      <button class="bundle-modal__backdrop" type="button" tabindex="-1" aria-label="Cerrar selector" data-bundle-close></button>
      <section class="bundle-modal__panel">
        <header class="bundle-modal__header">
          <div>
            <p>Pack Newborn · 25% OFF</p>
            <h2 id="pack-newborn-configurator-title">Elige tus dos diseños.</h2>
          </div>
          <button class="bundle-modal__close" type="button" aria-label="Cerrar selector" data-bundle-close>
            <img src="${assetUrl("brand/close.svg")}" width="24" height="24" alt="">
          </button>
        </header>
        <p class="bundle-modal__intro">Elige primero tu Original Wrap y luego tu Trendi Carrier. Aplicaremos el descuento automáticamente.</p>
        <form class="bundle-form" data-bundle-form>
          <div class="bundle-form__products">
            <article class="bundle-choice">
              <div class="bundle-choice__media"><img src="" width="480" height="560" alt="" data-bundle-image="wrap"></div>
              <div class="bundle-choice__copy">
                <span>Paso 1</span>
                <label for="bundle-wrap-design">${bundleConfig.wrap.title}</label>
                <select id="bundle-wrap-design" data-bundle-select="wrap">${choicesMarkup("wrap")}</select>
              </div>
            </article>
            <span class="bundle-form__plus" aria-hidden="true">+</span>
            <article class="bundle-choice">
              <div class="bundle-choice__media"><img src="" width="480" height="560" alt="" data-bundle-image="carrier"></div>
              <div class="bundle-choice__copy">
                <span>Paso 2</span>
                <label for="bundle-carrier-design">${bundleConfig.carrier.title}</label>
                <select id="bundle-carrier-design" data-bundle-select="carrier">${choicesMarkup("carrier")}</select>
              </div>
            </article>
          </div>
          <div class="bundle-form__summary">
            <p><span>Precio habitual</span><s>€${bundleRegularPrice.toFixed(2).replace(".", ",")}</s></p>
            <p class="bundle-form__subtotal"><span>Pack Newborn</span><span class="bundle-form__price"><strong>€${bundlePrice.toFixed(2).replace(".", ",")}</strong><small>Ahorras 25% (€${bundleSavings.toFixed(2).replace(".", ",")})</small></span></p>
          </div>
          <button class="button button--primary bundle-form__submit" type="submit">Agregar Pack Newborn al carrito</button>
          <p class="bundle-form__status" role="status" aria-live="polite" data-bundle-status></p>
        </form>
      </section>
    `;
    document.body.append(dialog);

    const form = dialog.querySelector("[data-bundle-form]");
    const status = dialog.querySelector("[data-bundle-status]");
    const submit = dialog.querySelector(".bundle-form__submit");
    let restoreTarget = null;
    let previousOverflow = "";
    let availabilityMessage = "";
    let availabilityRequest = null;

    const selectedVariant = (key) => {
      const select = dialog.querySelector(`[data-bundle-select="${key}"]`);
      return bundleConfig[key].variants.find((variant) =>
        variant.available && String(variant.id) === select?.value
      );
    };

    const updateChoice = (key) => {
      const variant = selectedVariant(key) || bundleConfig[key].variants.find((item) => item.available) || bundleConfig[key].variants[0];
      const image = dialog.querySelector(`[data-bundle-image="${key}"]`);
      if (!variant || !(image instanceof HTMLImageElement)) return;
      image.src = assetUrl(variant.image);
      image.alt = `${bundleConfig[key].title}, ${variant.label}`;
    };

    const renderBundleAvailability = () => {
      Object.keys(bundleConfig).forEach((key) => {
        const select = dialog.querySelector(`[data-bundle-select="${key}"]`);
        if (!(select instanceof HTMLSelectElement)) return;
        const previousValue = select.value;
        select.innerHTML = choicesMarkup(key);
        const previousVariant = bundleConfig[key].variants.find((variant) =>
          variant.available && String(variant.id) === previousValue
        );
        if (previousVariant) select.value = previousValue;
        select.disabled = !bundleConfig[key].variants.some((variant) => variant.available);
        updateChoice(key);
      });

      const unavailableProducts = Object.values(bundleConfig)
        .filter((config) => !config.variants.some((variant) => variant.available));
      availabilityMessage = unavailableProducts.length
        ? "El Pack Newborn no está disponible temporalmente porque sus diseños están agotados en Shopify."
        : "";
      submit.disabled = Boolean(availabilityMessage);
      status.textContent = availabilityMessage;
    };

    const refreshBundleAvailability = async () => {
      if (!shopifyStorefront) return;
      if (availabilityRequest) return availabilityRequest;

      availabilityRequest = Promise.all(Object.keys(bundleConfig).map(async (key) => {
        const response = await fetch(`${productConfig[key].shopifyPath}.js?availability=${Date.now()}`, {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
          cache: "no-store",
        });
        if (!response.ok) throw new Error(`No se pudo comprobar ${bundleConfig[key].title}`);
        return [key, await response.json()];
      })).then((products) => {
        products.forEach(([key, product]) => {
          const liveVariants = Array.isArray(product.variants) ? product.variants : [];
          const byId = new Map(liveVariants.map((variant) => [String(variant.id), variant]));
          const byLabel = new Map(liveVariants.map((variant) => [normalizedVariantLabel(variant.title), variant]));
          bundleConfig[key].variants.forEach((variant) => {
            const liveVariant = byId.get(String(variant.id)) || byLabel.get(normalizedVariantLabel(variant.label));
            if (!liveVariant) return;
            variant.id = liveVariant.id;
            variant.available = liveVariant.available !== false
              && liveVariantAvailable(key, liveVariant.title, variant.label);
          });
        });
      }).finally(() => {
        availabilityRequest = null;
      });

      return availabilityRequest;
    };

    const close = ({ restoreFocus = true } = {}) => {
      if (dialog.hidden) return;
      dialog.hidden = true;
      dialog.setAttribute("aria-hidden", "true");
      document.body.style.overflow = previousOverflow;
      if (restoreFocus && restoreTarget instanceof HTMLElement && restoreTarget.isConnected) {
        restoreTarget.focus({ preventScroll: true });
      }
    };

    const open = async (trigger) => {
      restoreTarget = trigger;
      previousOverflow = document.body.style.overflow;
      dialog.hidden = false;
      dialog.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      status.textContent = shopifyStorefront ? "Comprobando disponibilidad…" : availabilityMessage;
      submit.disabled = true;
      dialog.querySelectorAll("[data-bundle-select]").forEach((select) => {
        select.disabled = true;
      });

      try {
        await refreshBundleAvailability();
        renderBundleAvailability();
      } catch (_error) {
        renderBundleAvailability();
        status.textContent = availabilityMessage || "No pudimos actualizar la disponibilidad. Revisa tus diseños antes de continuar.";
      }

      window.requestAnimationFrame(() => dialog.querySelector("select:not([disabled])")?.focus({ preventScroll: true }));
    };

    dialog.querySelectorAll("[data-bundle-close]").forEach((button) => {
      button.addEventListener("click", () => close());
    });
    dialog.querySelectorAll("[data-bundle-select]").forEach((select) => {
      select.addEventListener("change", () => updateChoice(select.dataset.bundleSelect));
    });
    dialog.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== "Tab") return;

      const focusable = Array.from(dialog.querySelectorAll("button:not([disabled]), select:not([disabled])"))
        .filter((element) => !element.hidden && element.getClientRects().length > 0);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) return;

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    const addShopifyBundle = async (carrier, wrap) => {
      const root = window.Shopify?.routes?.root || "/";
      const properties = {
        "_Pack Newborn": "25% OFF",
        "_Diseños": `${carrier.label} + ${wrap.label}`,
      };
      const addResponse = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          items: [
            { id: carrier.id, quantity: 1, properties },
            { id: wrap.id, quantity: 1, properties },
          ],
        }),
      });
      const addResult = await addResponse.json().catch(() => ({}));
      if (!addResponse.ok) {
        const message = String(addResult.description || addResult.message || "");
        if (/sold out|out of stock|agotad/i.test(message)) {
          throw new Error("Uno de los diseños seleccionados está agotado en Shopify. Elige otra combinación.");
        }
        throw new Error(message || "Shopify no pudo agregar el pack. Inténtalo de nuevo.");
      }

      const discountResponse = await fetch(`${root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          discount: bundleDiscountCode,
          attributes: { "Pack Newborn": `${carrier.label} + ${wrap.label}` },
        }),
      });
      if (!discountResponse.ok) throw new Error("No se pudo aplicar el descuento");
      return discountResponse.json();
    };

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      let carrier = selectedVariant("carrier");
      let wrap = selectedVariant("wrap");
      if (!carrier || !wrap) {
        status.textContent = availabilityMessage || "Elige dos diseños disponibles.";
        return;
      }

      submit.disabled = true;
      submit.setAttribute("aria-busy", "true");
      submit.textContent = "Agregando tu pack…";
      status.textContent = "";

      try {
        if (shopifyStorefront) {
          await refreshBundleAvailability();
          renderBundleAvailability();
          carrier = selectedVariant("carrier");
          wrap = selectedVariant("wrap");
          if (!carrier || !wrap) {
            throw new Error("Uno de los diseños seleccionados ya no está disponible. Elige otra combinación.");
          }
          await addShopifyBundle(carrier, wrap);
          close({ restoreFocus: false });
          document.querySelector("[data-cart-open]")?.click();
        } else {
          const discountedCarrierPrice = bundleDiscountedPrice(bundleConfig.carrier.price);
          const discountedWrapPrice = bundleDiscountedPrice(bundleConfig.wrap.price);
          document.dispatchEvent(new CustomEvent("babiini:add-static-cart-items", {
            detail: {
              trigger: restoreTarget,
              items: [
                {
                  key: `bundle-carrier-${carrier.id}`,
                  quantity: 1,
                  name: bundleConfig.carrier.title,
                  color: carrier.label,
                  image: assetUrl(carrier.image),
                  price: discountedCarrierPrice,
                },
                {
                  key: `bundle-wrap-${wrap.id}`,
                  quantity: 1,
                  name: bundleConfig.wrap.title,
                  color: wrap.label,
                  image: assetUrl(wrap.image),
                  price: discountedWrapPrice,
                },
              ],
            },
          }));
          close({ restoreFocus: false });
        }
      } catch (error) {
        if (shopifyStorefront) {
          try {
            await refreshBundleAvailability();
            renderBundleAvailability();
          } catch (_availabilityError) {
            // Preserve Shopify's add-to-cart error when availability cannot be refreshed.
          }
        }
        status.textContent = error instanceof Error
          ? error.message
          : "No pudimos agregar el pack. Inténtalo de nuevo.";
      } finally {
        submit.disabled = Boolean(availabilityMessage);
        submit.removeAttribute("aria-busy");
        submit.textContent = "Agregar Pack Newborn al carrito";
      }
    });

    openers.forEach((opener) => {
      opener.setAttribute("aria-haspopup", "dialog");
      opener.setAttribute("aria-controls", dialog.id);
    });
    renderBundleAvailability();
    return { close, open };
  };

  const addShopifyVariant = async (button, { checkout = false, trigger = button } = {}) => {
    const key = productKeyFor(button);
    const variantId = variantIdFor(key, button);
    if (!variantId) return;

    const quantityInput = button.closest(".purchase-card")?.querySelector("[data-product-quantity]");
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || "1", 10) || 1);
    const root = window.Shopify?.routes?.root || "/";
    setLoadingState(trigger, true);

    try {
      if (checkout) {
        const localizedRoot = root.endsWith("/") ? root : `${root}/`;
        window.location.assign(`${localizedRoot}cart/${variantId}:${quantity}`);
        return;
      }

      const response = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
      });
      if (!response.ok) throw new Error("No se pudo agregar el producto");
      document.querySelector("[data-cart-open]")?.click();
    } catch (_error) {
      const originalLabel = trigger.dataset.cartOriginalLabel || trigger.textContent;
      setLoadingState(trigger, false);
      trigger.textContent = "Inténtalo de nuevo";
      window.setTimeout(() => {
        trigger.textContent = originalLabel;
      }, 2500);
    } finally {
      if (!checkout && trigger.hasAttribute("aria-busy")) setLoadingState(trigger, false);
    }
  };

  const renderCardAvailability = (card, addButton) => {
    const productKey = productKeyFor(addButton);
    const color = normalizedColorFor(productKey, addButton);
    const colorAliases = color === "Dessert Brown" ? [color, "Desert Brown"] : [color];
    const available = color ? liveVariantAvailable(productKey, ...colorAliases) : true;
    card.classList.toggle("is-unavailable", !available);
    card.querySelectorAll("[data-cart-add], [data-cart-buy-now]").forEach((button) => {
      button.disabled = !available;
      button.setAttribute("aria-disabled", String(!available));
      if (!available) {
        button.dataset.availableLabel ||= button.textContent;
        button.textContent = "Agotado";
        button.title = "Este diseño está agotado";
      } else if (button.dataset.availableLabel) {
        button.textContent = button.dataset.availableLabel;
        button.title = "";
        delete button.dataset.availableLabel;
      }
    });
  };

  const productCards = [...document.querySelectorAll(".product-card, .shop-card, .meta-product-card, .related-card, .reviews-product-card")];
  const originalCardOrder = new WeakMap(productCards.map((card, index) => [card, index]));
  const sortProductListsByAvailability = () => {
    const lists = new Map();
    productCards.forEach((card) => {
      const parent = card.parentElement;
      if (!parent) return;
      if (!lists.has(parent)) lists.set(parent, []);
      lists.get(parent).push(card);
    });

    lists.forEach((cards, parent) => {
      if (cards.length < 2) return;
      cards.sort((first, second) => {
        const availabilityDifference = Number(first.classList.contains("is-unavailable"))
          - Number(second.classList.contains("is-unavailable"));
        if (availabilityDifference) return availabilityDifference;

        const featuredDifference = Number(second.hasAttribute("data-featured-product"))
          - Number(first.hasAttribute("data-featured-product"));
        if (featuredDifference) return featuredDifference;
        return originalCardOrder.get(first) - originalCardOrder.get(second);
      });
      parent.append(...cards);
    });
  };

  productCards.forEach((card) => {
    const addButton = card.querySelector("[data-cart-add]");
    if (!addButton) return;
    const productKey = productKeyFor(addButton);
    if (!card.classList.contains("product-card")) card.classList.add("shop-card");
    const productLink = wrapProductVisual(card, productPathFor(productKey, addButton));
    setupCardNavigation(card, productLink);
    card.querySelector(".button--product-outline")?.remove();
    if (!card.querySelector("[data-cart-buy-now]")) addButton.after(buildBuyNowButton(addButton));
    renderCardAvailability(card, addButton);
  });
  sortProductListsByAvailability();

  let storefrontAvailabilityRequest = null;
  let lastStorefrontAvailabilityRefresh = 0;
  const refreshStorefrontAvailability = ({ force = false } = {}) => {
    if (!shopifyStorefront) return Promise.resolve();
    const now = Date.now();
    if (storefrontAvailabilityRequest) return storefrontAvailabilityRequest;
    if (!force && now - lastStorefrontAvailabilityRefresh < 15000) return Promise.resolve();
    lastStorefrontAvailabilityRefresh = now;

    storefrontAvailabilityRequest = Promise.all(["carrier", "wrap"].map(async (key) => {
      const response = await fetch(`${productConfig[key].shopifyPath}.js?inventory=${now}`, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        cache: "no-store",
      });
      if (!response.ok) throw new Error(`Inventory request failed with ${response.status}`);
      updateLiveProduct(key, await response.json());
    })).then(() => {
      productCards.forEach((card) => {
        const addButton = card.querySelector("[data-cart-add]");
        if (addButton) renderCardAvailability(card, addButton);
      });
      sortProductListsByAvailability();
      document.dispatchEvent(new CustomEvent("babiini:availabilitychange"));
    }).catch(() => {
      // Keep Shopify's server-rendered availability when a live refresh is unavailable.
    }).finally(() => {
      storefrontAvailabilityRequest = null;
    });

    return storefrontAvailabilityRequest;
  };

  refreshStorefrontAvailability();
  window.addEventListener("pageshow", (event) => {
    refreshStorefrontAvailability({ force: event.persisted });
  });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") refreshStorefrontAvailability({ force: true });
  });

  document.querySelectorAll("[data-cart-buy-now]").forEach((button) => {
    button.addEventListener("click", () => {
      const addButton = button.parentElement?.querySelector("[data-cart-add]");
      if (!addButton) return;
      if (!shopifyStorefront) {
        addButton.click();
        return;
      }
      addShopifyVariant(addButton, { checkout: true, trigger: button });
    });
  });

  const bundleConfigurator = setupBundleConfigurator();

  document.addEventListener("click", (event) => {
    const button = event.target instanceof Element ? event.target.closest("[data-cart-add]") : null;
    if (!(button instanceof HTMLButtonElement || button instanceof HTMLAnchorElement)) return;
    const productKey = productKeyFor(button);
    if (productKey === "pack" && bundleConfigurator) {
      event.preventDefault();
      event.stopImmediatePropagation();
      button.closest("[data-menu]")?.querySelector("[data-menu-close]")?.click();
      bundleConfigurator.open(button);
      return;
    }
    if (!shopifyStorefront) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addShopifyVariant(button, { checkout: button.dataset.cartMode === "checkout" });
  }, true);
})();


/* js/home.js */
(() => {
  "use strict";

  const MOBILE = window.matchMedia("(max-width: 767px)");
  const TABLET = window.matchMedia("(min-width: 768px) and (max-width: 991px)");
  const REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)");
  const FOCUSABLE = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "[tabindex]",
  ].join(",");
  const originalTabIndexes = new WeakMap();
  let generatedId = 0;

  const modulo = (value, length) => ((value % length) + length) % length;

  const mediaChange = (query, handler) => {
    if (typeof query.addEventListener === "function") {
      query.addEventListener("change", handler);
    } else {
      query.addListener(handler);
    }
  };

  const ensureId = (element, prefix) => {
    if (!element.id) {
      generatedId += 1;
      element.id = `${prefix}-${generatedId}`;
    }
    return element.id;
  };

  const controlsWithin = (element) => {
    const controls = Array.from(element.querySelectorAll(FOCUSABLE));
    if (element.matches(FOCUSABLE)) controls.unshift(element);
    return controls;
  };

  const setInteractive = (element, isInteractive) => {
    controlsWithin(element).forEach((control) => {
      if (!originalTabIndexes.has(control)) {
        originalTabIndexes.set(control, control.getAttribute("tabindex"));
      }

      if (!isInteractive) {
        control.tabIndex = -1;
        return;
      }

      const originalValue = originalTabIndexes.get(control);
      if (originalValue === null) control.removeAttribute("tabindex");
      else control.setAttribute("tabindex", originalValue);
    });
  };

  const setVisibleToAssistiveTech = (element, isVisible) => {
    element.setAttribute("aria-hidden", String(!isVisible));
    setInteractive(element, isVisible);
  };

  const isTypingTarget = (target) =>
    target instanceof Element &&
    (target.matches("input, textarea, select, [contenteditable='true']") ||
      Boolean(target.closest("input, textarea, select, [contenteditable='true']")));

  const applyMotionPreference = (root) => {
    const update = () => {
      root.dataset.motion = REDUCED_MOTION.matches ? "reduced" : "full";
      root.classList.toggle("is-reduced-motion", REDUCED_MOTION.matches);
    };
    update();
    mediaChange(REDUCED_MOTION, update);
  };

  const addSwipeNavigation = (element, { enabled = () => true, next, previous }) => {
    let start = null;
    let suppressClick = false;

    if (!element.style.touchAction) element.style.touchAction = "pan-y";

    element.addEventListener("pointerdown", (event) => {
      if (!enabled() || !event.isPrimary || (event.pointerType === "mouse" && event.button !== 0)) {
        return;
      }

      start = {
        x: event.clientX,
        y: event.clientY,
        pointerId: event.pointerId,
      };
    });

    element.addEventListener("pointerup", (event) => {
      if (!start || start.pointerId !== event.pointerId) return;

      const distanceX = event.clientX - start.x;
      const distanceY = event.clientY - start.y;
      start = null;

      if (Math.abs(distanceX) < 40 || Math.abs(distanceX) <= Math.abs(distanceY) * 1.15) return;

      suppressClick = true;
      if (distanceX < 0) next();
      else previous();

      window.setTimeout(() => {
        suppressClick = false;
      }, 0);
    });

    element.addEventListener("pointercancel", () => {
      start = null;
    });

    element.addEventListener(
      "click",
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true,
    );
  };

  const firstMatch = (root, selectors) => root.querySelector(selectors.join(","));

  const productCards = (root, track) => {
    const explicit = Array.from(track.querySelectorAll("[data-product-card]"));
    if (explicit.length) return explicit;

    const direct = Array.from(track.children).filter((child) =>
      child.matches("article, .product-card, .products-carousel__card"),
    );
    return direct.length ? direct : Array.from(root.querySelectorAll("[data-carousel-card]"));
  };

  const setupProductCarousel = (root) => {
    if (root.dataset.productCarouselReady === "true") return;

    const track =
      firstMatch(root, [
        "[data-product-track]",
        "[data-carousel-track]",
        ".product-carousel__stage",
      ]) || root;
    const cards = productCards(root, track);
    if (cards.length < 2) return;
    const usesShopCards = root.classList.contains("product-carousel--shop");

    root.dataset.productCarouselReady = "true";
    root.setAttribute("role", root.getAttribute("role") || "region");
    root.setAttribute("aria-roledescription", "carousel");
    if (!root.hasAttribute("aria-label")) root.setAttribute("aria-label", "Productos Babiini");
    if (!root.hasAttribute("tabindex")) root.tabIndex = 0;
    applyMotionPreference(root);

    const positions = ["side-left", "main-center", "side-right", "offstage"];
    const legacyPositions = [
      "tiny-left",
      "small-left",
      "main-left",
      "main-right",
      "small-right",
      "tiny-right",
    ];
    const positionClasses = [
      ...positions,
      ...positions.map((position) => `is-${position}`),
      ...legacyPositions,
      ...legacyPositions.map((position) => `is-${position}`),
    ];
    let offset = 0;
    let hoverResetPoint = null;

    const suppressHover = (event) => {
      root.classList.add("is-hover-suppressed");
      hoverResetPoint = event && Number.isFinite(event.clientX) && Number.isFinite(event.clientY)
        ? { x: event.clientX, y: event.clientY }
        : null;
    };

    const restoreHover = () => {
      root.classList.remove("is-hover-suppressed");
      hoverResetPoint = null;
    };

    root.addEventListener("pointerenter", (event) => {
      if (
        root.classList.contains("is-hover-suppressed") &&
        (!event.relatedTarget ||
          (event.relatedTarget instanceof Node && !root.contains(event.relatedTarget)))
      ) {
        restoreHover();
      }
    });
    root.addEventListener("pointermove", (event) => {
      if (!root.classList.contains("is-hover-suppressed") || !hoverResetPoint) return;
      if (Math.hypot(event.clientX - hoverResetPoint.x, event.clientY - hoverResetPoint.y) >= 12) {
        restoreHover();
      }
    });

    cards.forEach((card, index) => {
      card.setAttribute("role", "group");
      card.setAttribute("aria-roledescription", "slide");
      if (!card.hasAttribute("aria-label")) {
        card.setAttribute("aria-label", `${index + 1} de ${cards.length}`);
      }
    });

    const render = () => {
      if (usesShopCards) {
        Array.from(track.children).forEach((card, index) => {
          card.classList.remove(...positionClasses);
          delete card.dataset.carouselPosition;
          card.setAttribute("aria-label", `${index + 1} de ${cards.length}`);
          setVisibleToAssistiveTech(card, true);
        });
        root.dataset.carouselIndex = String(offset);
        return;
      }

      cards.forEach((card, index) => {
        const distance = modulo(index - offset, cards.length);
        const position = distance === 0
          ? "main-center"
          : distance === 1
            ? "side-right"
            : distance === cards.length - 1
              ? "side-left"
              : "offstage";
        const isPrimary = position === "main-center";

        card.classList.remove(...positionClasses);
        card.classList.add(position, `is-${position}`);
        card.dataset.carouselPosition = position;
        setVisibleToAssistiveTech(card, isPrimary);
      });
      root.dataset.carouselIndex = String(offset);
    };

    document.addEventListener("babiini:availabilitychange", () => {
      const currentCard = cards[offset];
      const orderedCards = productCards(root, track);
      cards.splice(0, cards.length, ...orderedCards);
      const currentIndex = cards.indexOf(currentCard);
      offset = currentIndex >= 0 && !currentCard?.classList.contains("is-unavailable")
        ? currentIndex
        : 0;
      cards.forEach((card, index) => {
        card.setAttribute("aria-label", `${index + 1} de ${cards.length}`);
      });
      render();
    });

    const move = (direction, event) => {
      offset = modulo(offset + direction, cards.length);
      suppressHover(event);
      root.dataset.carouselDirection = direction > 0 ? "next" : "previous";
      if (usesShopCards) {
        if (direction > 0) track.append(track.firstElementChild);
        else track.prepend(track.lastElementChild);
      }
      render();
    };

    const previous = firstMatch(root, [
      "[data-product-prev]",
      "[data-carousel-prev]",
      "[data-prev]",
    ]);
    const next = firstMatch(root, [
      "[data-product-next]",
      "[data-carousel-next]",
      "[data-next]",
    ]);
    const trackId = ensureId(track, "product-carousel-track");

    if (previous) {
      previous.setAttribute("aria-label", previous.getAttribute("aria-label") || "Producto anterior");
      previous.setAttribute("aria-controls", trackId);
      previous.addEventListener("click", (event) => move(-1, event));
    }
    if (next) {
      next.setAttribute("aria-label", next.getAttribute("aria-label") || "Siguiente producto");
      next.setAttribute("aria-controls", trackId);
      next.addEventListener("click", (event) => move(1, event));
    }

    root.addEventListener("keydown", (event) => {
      if (isTypingTarget(event.target)) return;
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        move(-1);
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        move(1);
      }
    });

    if (usesShopCards) {
      addSwipeNavigation(track, {
        next: () => move(1),
        previous: () => move(-1),
      });
    } else {
      let pointerId = null;
      let startX = 0;
      let currentX = 0;
      let pointerLink = null;
      let suppressClick = false;
      let wheelDistance = 0;
      let wheelDirection = 0;
      let wheelGestureLocked = false;
      let wheelReset = 0;
      let wheelLowestMagnitude = Number.POSITIVE_INFINITY;
      let wheelMoveTime = 0;

      track.style.touchAction = "pan-y";
      track.addEventListener("dragstart", (event) => event.preventDefault());

      const clearDragStyles = () => {
        root.style.setProperty("--carousel-drag-x", "0px");
        root.style.removeProperty("--carousel-center-drag-scale");
        root.style.removeProperty("--carousel-center-drag-opacity");
        root.style.removeProperty("--carousel-side-drag-scale");
        root.style.removeProperty("--carousel-side-drag-opacity");
        delete root.dataset.carouselDragDirection;
      };

      const resetDrag = () => {
        clearDragStyles();
        root.classList.remove("is-dragging");
        pointerId = null;
      };

      track.addEventListener("pointerdown", (event) => {
        if (!event.isPrimary || (event.pointerType === "mouse" && event.button !== 0)) return;
        if (
          event.target instanceof Element &&
          event.target.closest("button, input, select, textarea, [role='button']")
        ) {
          return;
        }
        pointerId = event.pointerId;
        startX = event.clientX;
        currentX = startX;
        pointerLink =
          event.target.closest("a[href]") ||
          event.target.closest(".is-product-link")?.querySelector("a[href]") ||
          null;
      });

      track.addEventListener("pointermove", (event) => {
        if (pointerId !== event.pointerId) return;
        currentX = event.clientX;
        const distance = currentX - startX;
        if (Math.abs(distance) >= 4) {
          root.classList.add("is-dragging");
          suppressHover(event);
        }
        if (Math.abs(distance) >= 8 && !track.hasPointerCapture?.(pointerId)) {
          track.setPointerCapture?.(pointerId);
        }
        const progress = Math.min(1, Math.abs(distance) / 180);
        const sideScale =
          Number.parseFloat(
            window.getComputedStyle(root).getPropertyValue("--carousel-side-scale"),
          ) || 0.58;
        root.style.setProperty("--carousel-drag-x", `${Math.max(-180, Math.min(180, distance))}px`);
        root.style.setProperty("--carousel-center-drag-scale", String(1 - progress * 0.12));
        root.style.setProperty("--carousel-center-drag-opacity", String(1 - progress * 0.35));
        root.style.setProperty("--carousel-side-drag-scale", String(sideScale + progress * 0.18));
        root.style.setProperty("--carousel-side-drag-opacity", String(0.34 + progress * 0.5));
        root.dataset.carouselDragDirection = distance < 0 ? "next" : distance > 0 ? "previous" : "";
      });

      const finishDrag = (event) => {
        if (pointerId !== event.pointerId) return;
        const distance = currentX - startX;
        const clickLink = pointerLink;
        if (track.hasPointerCapture?.(pointerId)) track.releasePointerCapture?.(pointerId);
        pointerLink = null;

        if (Math.abs(distance) >= 42) {
          root.classList.remove("is-dragging");
          void track.offsetWidth;
          clearDragStyles();
          pointerId = null;
          move(distance < 0 ? 1 : -1, event);
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 0);
        } else {
          resetDrag();
        }

        if (Math.abs(distance) > 6 && Math.abs(distance) < 42 && clickLink instanceof HTMLAnchorElement) {
          window.setTimeout(() => clickLink.click(), 0);
        }
      };

      track.addEventListener("pointerup", finishDrag);
      track.addEventListener("pointercancel", (event) => {
        if (pointerId !== event.pointerId) return;
        pointerLink = null;
        resetDrag();
      });
      track.addEventListener(
        "click",
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true,
      );

      track.addEventListener(
        "wheel",
        (event) => {
          const horizontalGesture = Math.abs(event.deltaX) > Math.abs(event.deltaY) * 1.15;
          const shiftedGesture = event.shiftKey && Math.abs(event.deltaY) > 0;
          if (!horizontalGesture && !shiftedGesture) return;

          const rawDistance = horizontalGesture ? event.deltaX : event.deltaY;
          const deltaMultiplier = event.deltaMode === 1
            ? 16
            : event.deltaMode === 2
              ? root.clientWidth
              : 1;
          const distance = rawDistance * deltaMultiplier;
          if (!distance) return;

          event.preventDefault();
          window.clearTimeout(wheelReset);
          wheelReset = window.setTimeout(() => {
            wheelDistance = 0;
            wheelDirection = 0;
            wheelGestureLocked = false;
            wheelLowestMagnitude = Number.POSITIVE_INFINITY;
          }, 140);

          const direction = Math.sign(distance);
          const magnitude = Math.abs(distance);

          if (wheelGestureLocked) {
            wheelLowestMagnitude = Math.min(wheelLowestMagnitude, magnitude);
            const isOppositeImpulse = wheelDirection !== direction;
            const isFreshImpulse =
              performance.now() - wheelMoveTime >= 110 &&
              magnitude >= Math.max(10, wheelLowestMagnitude * 1.65);

            if (!isOppositeImpulse && !isFreshImpulse) return;

            wheelDistance = 0;
            wheelGestureLocked = false;
            wheelLowestMagnitude = Number.POSITIVE_INFINITY;
          }

          if (wheelDirection && wheelDirection !== direction) {
            wheelDistance = 0;
          }
          wheelDirection = direction;
          wheelDistance += distance;

          if (Math.abs(wheelDistance) < 64) return;
          move(direction > 0 ? 1 : -1, event);
          wheelDistance = 0;
          wheelGestureLocked = true;
          wheelLowestMagnitude = magnitude;
          wheelMoveTime = performance.now();
        },
        { passive: false },
      );
    }
    render();
  };

  const directSliderItems = (root, itemSelector) => {
    const explicit = Array.from(root.querySelectorAll(itemSelector));
    if (explicit.length) return explicit;

    const track = firstMatch(root, ["[data-slider-track]", "[data-carousel-track]"]) || root;
    return Array.from(track.children).filter(
      (child) => !child.matches("[data-slider-dots], [data-trust-dots], [data-promo-dots]"),
    );
  };

  const setupMobilePagedSlider = ({
    root,
    itemSelector,
    kind,
    label,
  }) => {
    if (!root || root.dataset[`${kind}SliderReady`] === "true") return;

    const items = directSliderItems(root, itemSelector);
    if (items.length < 2) return;

    root.dataset[`${kind}SliderReady`] = "true";
    root.setAttribute("role", root.getAttribute("role") || "region");
    root.setAttribute("aria-roledescription", "carousel");
    if (!root.hasAttribute("aria-label")) root.setAttribute("aria-label", label);
    applyMotionPreference(root);

    const originalRootTabIndex = root.getAttribute("tabindex");
    let activeIndex = 0;
    let dots = firstMatch(root, [`[data-${kind}-dots]`, "[data-slider-dots]"]);

    if (!dots) {
      dots = document.createElement("div");
      dots.dataset[`${kind}Dots`] = "";
      dots.className = `paged-slider__dots ${kind}-slider__dots`;
      root.append(dots);
    }

    dots.replaceChildren();
    dots.setAttribute("role", "tablist");
    dots.setAttribute("aria-label", `${label}: seleccionar diapositiva`);

    const dotButtons = items.map((item, index) => {
      const itemId = ensureId(item, `${kind}-slide`);
      item.setAttribute("role", "group");
      item.setAttribute("aria-roledescription", "slide");
      if (!item.hasAttribute("aria-label")) {
        item.setAttribute("aria-label", `${index + 1} de ${items.length}`);
      }

      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = `paged-slider__dot ${kind}-slider__dot`;
      dot.setAttribute("role", "tab");
      dot.setAttribute("aria-controls", itemId);
      dot.setAttribute("aria-label", `Ver opción ${index + 1} de ${items.length}`);
      dot.addEventListener("click", () => setActive(index));
      dots.append(dot);
      return dot;
    });

    const render = () => {
      const isMobile = MOBILE.matches;
      root.classList.toggle("is-mobile-slider", isMobile);
      root.dataset.activeIndex = String(activeIndex);
      dots.hidden = !isMobile;

      if (isMobile) root.tabIndex = 0;
      else if (originalRootTabIndex === null) root.removeAttribute("tabindex");
      else root.setAttribute("tabindex", originalRootTabIndex);

      items.forEach((item, index) => {
        let slideOffset = index - activeIndex;
        if (slideOffset > items.length / 2) slideOffset -= items.length;
        if (slideOffset < -items.length / 2) slideOffset += items.length;

        const isActive = index === activeIndex;
        item.style.setProperty("--slide-offset", String(slideOffset));
        item.dataset.slideOffset = String(slideOffset);
        item.classList.toggle("is-active", isMobile && isActive);

        if (isMobile) setVisibleToAssistiveTech(item, isActive);
        else {
          item.removeAttribute("aria-hidden");
          setInteractive(item, true);
        }
      });

      dotButtons.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-selected", String(isActive));
        if (isActive) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
        dot.tabIndex = isActive ? 0 : -1;
      });
    };

    function setActive(index) {
      activeIndex = modulo(index, items.length);
      render();
    }

    root.addEventListener("keydown", (event) => {
      if (!MOBILE.matches || isTypingTarget(event.target)) return;
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        setActive(activeIndex - 1);
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        setActive(activeIndex + 1);
      }
    });

    addSwipeNavigation(root, {
      enabled: () => MOBILE.matches,
      next: () => setActive(activeIndex + 1),
      previous: () => setActive(activeIndex - 1),
    });
    mediaChange(MOBILE, render);
    render();
  };

  const testimonialCards = (root, track) => {
    const explicit = Array.from(
      track.querySelectorAll("[data-testimonial-card], [data-testimonial]"),
    );
    if (explicit.length) return explicit;
    return Array.from(track.children).filter((child) =>
      child.matches("article, .testimonial-card, .testimonials__card"),
    );
  };

  const setupTestimonialSlider = (root) => {
    if (root.dataset.testimonialSliderReady === "true") return;

    const track =
      firstMatch(root, ["[data-testimonial-track]", "[data-slider-track]"]) || root;
    const cards = testimonialCards(root, track);
    if (cards.length < 2) return;

    root.dataset.testimonialSliderReady = "true";
    root.setAttribute("role", root.getAttribute("role") || "region");
    root.setAttribute("aria-roledescription", "carousel");
    if (!root.hasAttribute("aria-label")) root.setAttribute("aria-label", "Historias Babiini");
    if (!root.hasAttribute("tabindex")) root.tabIndex = 0;
    applyMotionPreference(root);

    const trackId = ensureId(track, "testimonial-track");
    const previous = firstMatch(root, [
      "[data-testimonial-prev]",
      "[data-carousel-prev]",
      "[data-prev]",
    ]);
    const next = firstMatch(root, [
      "[data-testimonial-next]",
      "[data-carousel-next]",
      "[data-next]",
    ]);
    const status = root.querySelector("[data-testimonial-status]") || document.createElement("p");
    status.classList.add("sr-only", "testimonial-slider__status");
    status.setAttribute("aria-live", "polite");
    status.setAttribute("aria-atomic", "true");
    if (!status.isConnected) root.append(status);

    let activeIndex = MOBILE.matches ? 1 : 0;
    const visibleCount = () => Math.min(cards.length, MOBILE.matches ? 1 : TABLET.matches ? 2 : 3);

    cards.forEach((card, index) => {
      card.setAttribute("role", "group");
      card.setAttribute("aria-roledescription", "slide");
      if (!card.hasAttribute("aria-label")) {
        card.setAttribute("aria-label", `${index + 1} de ${cards.length}`);
      }
    });

    const render = ({ announce = false } = {}) => {
      const count = visibleCount();
      const visibleTitles = [];

      cards.forEach((card, index) => {
        const distance = modulo(index - activeIndex, cards.length);
        const isVisible = distance < count;
        card.hidden = !isVisible;
        card.style.order = String(distance);
        card.classList.toggle("is-active", isVisible);
        setVisibleToAssistiveTech(card, isVisible);

        if (isVisible) {
          const title = card.querySelector("[data-testimonial-title], h3")?.textContent?.trim();
          if (title) visibleTitles.push(title);
        }
      });

      root.dataset.activeIndex = String(activeIndex);
      root.dataset.visibleCount = String(count);
      const canMove = cards.length > count;
      [previous, next].forEach((control) => {
        if (!control) return;
        control.disabled = !canMove;
        control.setAttribute("aria-disabled", String(!canMove));
      });

      if (announce) {
        status.textContent =
          count === 1
            ? `Mostrando: ${visibleTitles[0] || "testimonio"}`
            : `Mostrando ${count} testimonios: ${visibleTitles.join(", ")}`;
      }
    };

    const move = (direction) => {
      if (cards.length <= visibleCount()) return;
      activeIndex = modulo(activeIndex + direction, cards.length);
      root.dataset.carouselDirection = direction > 0 ? "next" : "previous";
      render({ announce: true });
    };

    if (previous) {
      previous.setAttribute(
        "aria-label",
        previous.getAttribute("aria-label") || "Testimonio anterior",
      );
      previous.setAttribute("aria-controls", trackId);
      previous.addEventListener("click", () => move(-1));
    }
    if (next) {
      next.setAttribute(
        "aria-label",
        next.getAttribute("aria-label") || "Siguiente testimonio",
      );
      next.setAttribute("aria-controls", trackId);
      next.addEventListener("click", () => move(1));
    }

    root.addEventListener("keydown", (event) => {
      if (isTypingTarget(event.target)) return;
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        move(-1);
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        move(1);
      }
    });

    addSwipeNavigation(track, {
      enabled: () => MOBILE.matches,
      next: () => move(1),
      previous: () => move(-1),
    });
    mediaChange(MOBILE, () => render());
    mediaChange(TABLET, () => render());
    render();
  };

  const reorderHomepageSections = () => {
    const main = document.querySelector(".home-2026");
    const hero = main?.querySelector(":scope > .home-hero");
    const offer = main?.querySelector(":scope > .monthly-offer");
    if (!hero || !offer || hero.nextElementSibling === offer) return;
    hero.insertAdjacentElement("afterend", offer);
  };

  const setupPromoNewsletter = () => {
    document.querySelectorAll("[data-promo-newsletter-open]").forEach((opener) => {
      const panelId = opener.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;
      const form = panel?.querySelector("[data-promo-newsletter-form]");
      const status = panel?.querySelector("[data-promo-newsletter-status]");
      const success = panel?.querySelector("[data-promo-newsletter-success]");
      const closeButton = panel?.querySelector("[data-promo-newsletter-close]");
      const copyButton = panel?.querySelector("[data-promo-newsletter-copy]");
      const code = success?.querySelector("code");
      const email = form?.querySelector("input[type='email']");
      if (!panel || !form || !status || !success || !closeButton || !copyButton || !code || !email) return;

      // Shopify's captcha bootstrap can call the native form.submit(), which
      // bypasses submit handlers and refreshes the page. This form is handled
      // asynchronously below, so keep it outside that native fallback.
      form.dataset.nocaptcha = "true";

      const showPanel = () => {
        if (typeof panel.showModal === "function" && !panel.open) panel.showModal();
        else panel.setAttribute("open", "");
        opener.setAttribute("aria-expanded", "true");
      };

      const showSuccess = (submittedEmail) => {
        if (!submittedEmail || !email.checkValidity()) return false;
        form.hidden = true;
        success.hidden = false;
        showPanel();
        window.requestAnimationFrame(() => success.focus({ preventScroll: true }));
        return true;
      };

      const closePanel = () => {
        if (typeof panel.close === "function" && panel.open) panel.close();
        else panel.removeAttribute("open");
        opener.setAttribute("aria-expanded", "false");
      };

      opener.addEventListener("click", () => {
        showPanel();
        window.requestAnimationFrame(() => email.focus());
      });

      closeButton.addEventListener("click", closePanel);
      panel.addEventListener("close", () => opener.setAttribute("aria-expanded", "false"));
      panel.addEventListener("click", (event) => {
        if (event.target === panel) closePanel();
      });

      email.addEventListener("input", () => {
        email.setCustomValidity("");
        email.removeAttribute("aria-invalid");
        status.hidden = true;
        status.textContent = "";
      });

      copyButton.addEventListener("click", async () => {
        const originalLabel = copyButton.textContent;
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(code.textContent.trim());
          } else {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(code);
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("copy");
            selection.removeAllRanges();
          }
          copyButton.textContent = "Código copiado";
          copyButton.classList.remove("is-copied");
          window.requestAnimationFrame(() => copyButton.classList.add("is-copied"));
        } catch {
          copyButton.textContent = "Selecciona y copia el código";
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(code);
          selection.removeAllRanges();
          selection.addRange(range);
        }
        window.setTimeout(() => {
          copyButton.textContent = originalLabel;
          copyButton.classList.remove("is-copied");
        }, 2200);
      });

      form.addEventListener("submit", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const submit = form.querySelector("button[type='submit']");
        email.value = email.value.trim();

        const errorMessage = "Introduce un correo electrónico válido.";
        const hasFullEmailDomain = window.babiiniIsFullEmail?.(email.value) === true;
        email.setCustomValidity(hasFullEmailDomain ? "" : errorMessage);

        if (!hasFullEmailDomain || !form.checkValidity()) {
          email.setAttribute("aria-invalid", "true");
          status.textContent = errorMessage;
          status.hidden = false;
          email.focus();
          form.reportValidity();
          return;
        }

        const submittedEmail = email.value;
        const formData = new FormData(form);
        submit.disabled = true;
        status.hidden = true;
        status.textContent = "";
        if (!showSuccess(submittedEmail)) {
          submit.disabled = false;
          return;
        }
        form.reset();

        if (window.Shopify?.shop) {
          fetch(form.action, {
            method: "POST",
            body: formData,
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" },
          }).catch(() => {
            // The discount code remains visible even if Shopify cannot record
            // the newsletter subscription in the background.
          });
        }
      });

    });
  };

  const setupFirstPurchaseDiscount = () => {
    const dialog = document.querySelector("[data-first-purchase-discount]");
    const launcher = document.querySelector("[data-first-purchase-open]");
    const closeButton = dialog?.querySelector("[data-first-purchase-close]");
    const applyButton = dialog?.querySelector("[data-first-purchase-apply]");
    const status = dialog?.querySelector("[data-first-purchase-status]");
    if (!(dialog instanceof HTMLDialogElement) || !(launcher instanceof HTMLButtonElement) || !(closeButton instanceof HTMLButtonElement) || !(applyButton instanceof HTMLButtonElement) || !(status instanceof HTMLElement)) return;

    const discountCode = dialog.dataset.discountCode || "SEXYMOMMA";
    const seenKey = "babiini-first-purchase-popup-seen";
    const showDialog = () => {
      if (!dialog.open) {
        if (typeof dialog.showModal === "function") dialog.showModal();
        else dialog.setAttribute("open", "");
      }
      launcher.setAttribute("aria-expanded", "true");
    };
    const closeDialog = () => {
      if (dialog.open && typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
      launcher.setAttribute("aria-expanded", "false");
    };

    launcher.addEventListener("click", showDialog);
    closeButton.addEventListener("click", closeDialog);
    dialog.addEventListener("close", () => launcher.setAttribute("aria-expanded", "false"));
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) closeDialog();
    });

    applyButton.addEventListener("click", async () => {
      applyButton.disabled = true;
      status.hidden = false;
      status.classList.remove("is-error");
      status.textContent = "Activando tu descuento…";

      try {
        const isShopify = Boolean(window.Shopify?.shop || window.Shopify?.routes?.root);
        if (isShopify) {
          const root = window.Shopify?.routes?.root || "/";
          const redirect = `${window.location.pathname}${window.location.search}`;
          const response = await fetch(`${root}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(redirect)}`, {
            credentials: "same-origin",
            redirect: "follow",
          });
          if (!response.ok) throw new Error(`Discount activation failed with ${response.status}`);
        }
        window.localStorage?.setItem("babiini-first-purchase-discount", discountCode);
        status.textContent = "¡Listo! El 20% de descuento quedó activado para tu carrito.";
        applyButton.textContent = "Descuento activado";
        window.setTimeout(() => closeDialog(), 1200);
      } catch {
        applyButton.disabled = false;
        status.classList.add("is-error");
        status.textContent = "No pudimos activar el descuento. Inténtalo de nuevo.";
      }
    });

    if (!window.sessionStorage?.getItem(seenKey)) {
      window.sessionStorage?.setItem(seenKey, "true");
      window.setTimeout(showDialog, 1400);
    }
  };

  const initialize = () => {
    reorderHomepageSections();
    document.querySelectorAll("[data-product-carousel]").forEach(setupProductCarousel);

    document.querySelectorAll("[data-trust-slider]").forEach((root) => {
      setupMobilePagedSlider({
        root,
        itemSelector: "[data-trust-card]",
        kind: "trust",
        label: "Beneficios Babiini",
      });
    });

    document.querySelectorAll("[data-promo-slider]").forEach((root) => {
      setupMobilePagedSlider({
        root,
        itemSelector: "[data-promo-card]",
        kind: "promo",
        label: "Promociones Babiini",
      });
    });

    document.querySelectorAll("[data-testimonial-slider]").forEach(setupTestimonialSlider);
    setupFirstPurchaseDiscount();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();


/* js/about.js */
(() => {
  "use strict";

  const mobile = window.matchMedia("(max-width: 767px)");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function setupCareSlider(root) {
    const track = root.querySelector("[data-care-track]");
    const cards = Array.from(root.querySelectorAll("[data-care-card]"));
    const dotsRoot = root.querySelector("[data-care-dots]");
    const status = root.querySelector("[data-care-status]");

    if (!track || cards.length < 2 || !dotsRoot) return;

    let index = 0;
    let pointerStart = null;

    const dots = cards.map((card, cardIndex) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", `Mostrar ${card.querySelector("h3")?.textContent || `beneficio ${cardIndex + 1}`}`);
      dot.addEventListener("click", () => show(cardIndex));
      dotsRoot.append(dot);
      return dot;
    });

    function show(nextIndex) {
      index = (nextIndex + cards.length) % cards.length;
      track.style.setProperty("--care-index", String(index));

      cards.forEach((card, cardIndex) => {
        const isCurrent = cardIndex === index;
        card.setAttribute("aria-hidden", mobile.matches && !isCurrent ? "true" : "false");
        if (mobile.matches && !isCurrent) {
          card.setAttribute("inert", "");
        } else {
          card.removeAttribute("inert");
        }
      });

      dots.forEach((dot, dotIndex) => {
        dot.setAttribute("aria-current", dotIndex === index ? "true" : "false");
      });

      if (status && mobile.matches) {
        status.textContent = `${index + 1} de ${cards.length}: ${cards[index].querySelector("h3")?.textContent || "Beneficio"}`;
      }
    }

    track.addEventListener("pointerdown", (event) => {
      if (!mobile.matches || event.pointerType === "mouse") return;
      pointerStart = event.clientX;
    });

    track.addEventListener("pointerup", (event) => {
      if (pointerStart === null || !mobile.matches) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) < 36) return;
      show(index + (distance < 0 ? 1 : -1));
    });

    track.addEventListener("pointercancel", () => {
      pointerStart = null;
    });

    root.addEventListener("keydown", (event) => {
      if (!mobile.matches) return;
      if (event.key === "ArrowLeft") show(index - 1);
      if (event.key === "ArrowRight") show(index + 1);
    });

    mobile.addEventListener?.("change", () => show(index));
    show(0);
  }

  function setupProductControls(root) {
    const track = root.querySelector("[data-about-product-track]");
    const previous = root.querySelector("[data-about-product-prev]");
    const next = root.querySelector("[data-about-product-next]");

    if (!track || !previous || !next || track.children.length < 2) return;

    const move = (direction) => {
      track.classList.add("is-changing");

      window.setTimeout(() => {
        if (direction > 0) {
          track.append(track.firstElementChild);
        } else {
          track.prepend(track.lastElementChild);
        }
        track.classList.remove("is-changing");
      }, reducedMotion.matches ? 0 : 140);
    };

    previous.addEventListener("click", () => move(-1));
    next.addEventListener("click", () => move(1));
  }

  document.querySelectorAll("[data-care-slider]").forEach(setupCareSlider);
  document.querySelectorAll("[data-about-products]").forEach(setupProductControls);
})();


/* js/products-general.js */
(() => {
  "use strict";

  const mobile = window.matchMedia("(max-width: 767px)");

  function setupSlider(root) {
    const track = root.querySelector("[data-products-track]");
    const slides = Array.from(root.querySelectorAll("[data-products-slide]"));
    const dotsRoot = root.querySelector("[data-products-dots]");
    const status = root.querySelector("[data-products-status]");

    if (!track || slides.length < 2 || !dotsRoot) return;

    let index = 0;
    let pointerStart = null;

    const dots = slides.map((slide, slideIndex) => {
      const dot = document.createElement("button");
      const label = slide.querySelector("h2, h3")?.textContent?.trim() || `opción ${slideIndex + 1}`;
      dot.type = "button";
      dot.setAttribute("aria-label", `Mostrar ${label}`);
      dot.addEventListener("click", () => show(slideIndex));
      dotsRoot.append(dot);
      return dot;
    });

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.setProperty("--products-index", String(index));

      slides.forEach((slide, slideIndex) => {
        const isCurrent = slideIndex === index;
        slide.setAttribute("aria-hidden", mobile.matches && !isCurrent ? "true" : "false");
        if (mobile.matches && !isCurrent) {
          slide.setAttribute("inert", "");
        } else {
          slide.removeAttribute("inert");
        }
      });

      dots.forEach((dot, dotIndex) => {
        dot.setAttribute("aria-current", dotIndex === index ? "true" : "false");
      });

      if (status && mobile.matches) {
        const label = slides[index].querySelector("h2, h3")?.textContent?.trim() || "Opción";
        status.textContent = `${index + 1} de ${slides.length}: ${label}`;
      }
    }

    track.addEventListener("pointerdown", (event) => {
      if (!mobile.matches || event.pointerType === "mouse") return;
      pointerStart = event.clientX;
    });

    track.addEventListener("pointerup", (event) => {
      if (!mobile.matches || pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) < 36) return;
      show(index + (distance < 0 ? 1 : -1));
    });

    track.addEventListener("pointercancel", () => {
      pointerStart = null;
    });

    root.addEventListener("keydown", (event) => {
      if (!mobile.matches) return;
      if (event.key === "ArrowLeft") show(index - 1);
      if (event.key === "ArrowRight") show(index + 1);
    });

    mobile.addEventListener?.("change", () => show(index));
    show(0);
  }

  document.querySelectorAll("[data-products-slider]").forEach(setupSlider);
})();


/* js/review-modal.js */
(() => {
  "use strict";

  const focusableSelector = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled]):not([type='hidden'])",
    "textarea:not([disabled])",
    "[tabindex]:not([tabindex='-1'])",
  ].join(",");

  function setupReviewModal() {
    const modal = document.querySelector("[data-review-modal]");
    const form = modal?.querySelector("[data-review-form]");
    const openers = Array.from(document.querySelectorAll("[data-review-open]"));
    const closers = Array.from(document.querySelectorAll("[data-review-close]"));
    if (!modal || !form || !openers.length) return;

    const starButtons = Array.from(modal.querySelectorAll("[data-rating]"));
    const ratingValue = modal.querySelector("[data-rating-value]");
    const comment = form.elements.namedItem("comment");
    const name = form.elements.namedItem("name");
    const email = form.elements.namedItem("email");
    const product = form.elements.namedItem("product");
    const status = modal.querySelector("[data-review-status]");
    let restoreFocus = null;
    let rating = 0;

    function focusableElements() {
      return Array.from(modal.querySelectorAll(focusableSelector)).filter((element) => {
        const style = window.getComputedStyle(element);
        return style.display !== "none" && style.visibility !== "hidden" && element.getClientRects().length;
      });
    }

    function setRating(value, { focus = false } = {}) {
      rating = value;
      if (ratingValue) ratingValue.value = String(value);
      starButtons.forEach((button, index) => {
        const selected = index < value;
        button.classList.toggle("is-active", selected);
        button.setAttribute("aria-checked", String(index + 1 === value));
        button.tabIndex = index + 1 === value || (!value && index === 0) ? 0 : -1;
      });
      if (focus) starButtons[Math.max(0, value - 1)]?.focus();
      if (status) status.textContent = "";
    }

    function open(opener) {
      restoreFocus = opener || document.activeElement;
      if (status) status.textContent = "";
      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("is-scroll-locked");
      document.body.classList.add("is-scroll-locked");
      modal.querySelector("[data-review-close]")?.focus({ preventScroll: true });
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("is-scroll-locked");
      document.body.classList.remove("is-scroll-locked");
      if (restoreFocus instanceof HTMLElement && restoreFocus.isConnected) restoreFocus.focus();
    }

    openers.forEach((opener) => {
      opener.addEventListener("click", (event) => {
        event.preventDefault();
        open(opener);
      });
    });
    closers.forEach((closer) => closer.addEventListener("click", close));

    modal.addEventListener("pointerdown", (event) => {
      if (event.target === modal && window.innerWidth > 767) close();
    });

    modal.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        close();
        return;
      }

      if (event.key !== "Tab") return;
      const focusable = focusableElements();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    starButtons.forEach((button, index) => {
      button.addEventListener("click", () => setRating(index + 1));
      button.addEventListener("keydown", (event) => {
        if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
        event.preventDefault();
        let next = index + 1;
        if (event.key === "ArrowLeft") next = Math.max(1, index);
        if (event.key === "ArrowRight") next = Math.min(5, index + 2);
        if (event.key === "Home") next = 1;
        if (event.key === "End") next = 5;
        setRating(next, { focus: true });
      });
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const commentValue = comment instanceof HTMLTextAreaElement ? comment.value.trim() : "";
      const nameValue = name instanceof HTMLInputElement ? name.value.trim() : "";
      const emailValue = email instanceof HTMLInputElement ? email.value.trim() : "";
      const productValue = product instanceof HTMLSelectElement ? product.value.trim() : "";

      if (!rating) {
        if (status) status.textContent = "Selecciona una calificación antes de enviar.";
        starButtons[0]?.focus();
        return;
      }

      if (!commentValue) {
        if (status) status.textContent = "Escribe un comentario antes de enviar.";
        comment?.focus();
        return;
      }

      if (!nameValue) {
        if (status) status.textContent = "Escribe tu nombre antes de enviar.";
        name?.focus();
        return;
      }

      if (!emailValue || !(email instanceof HTMLInputElement) || !email.checkValidity()) {
        if (status) status.textContent = "Escribe un correo electrónico válido.";
        email?.focus();
        return;
      }

      if (!productValue) {
        if (status) status.textContent = "Selecciona el producto sobre el que escribes.";
        product?.focus();
        return;
      }

      const submit = form.querySelector("button[type='submit']");
      if (submit instanceof HTMLButtonElement) submit.disabled = true;
      if (status) status.textContent = "Enviando tu comentario…";

      const payload = new URLSearchParams({
        form_type: "contact",
        utf8: "✓",
        "contact[name]": nameValue,
        "contact[email]": emailValue,
        "contact[product]": productValue,
        "contact[rating]": `${rating} de 5`,
        "contact[body]": commentValue,
        "contact[tags]": "review,customer-review",
      });

      try {
        const response = await fetch(form.action || "/contact", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
          body: payload,
        });
        if (!response.ok) throw new Error("Review submission failed");

        form.reset();
        setRating(0);
        if (status) status.textContent = "Gracias. Tu comentario se ha enviado para revisión.";
      } catch (_error) {
        if (status) status.textContent = "No pudimos enviar tu comentario. Inténtalo de nuevo.";
      } finally {
        if (submit instanceof HTMLButtonElement) submit.disabled = false;
      }
    });

    modal.setAttribute("aria-hidden", "true");
    setRating(0);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupReviewModal, { once: true });
  } else {
    setupReviewModal();
  }
})();


/* js/reviews.js */
(() => {
  "use strict";

  function setupReviewTabs() {
    document.querySelectorAll("[data-review-view]").forEach((view) => {
      const list = view.querySelector("[data-review-list]");
      const tabs = Array.from(view.querySelectorAll("[data-review-filter]"));
      if (!list || !tabs.length) return;

      const reviews = Array.from(list.querySelectorAll("article"));

      function activate(tab, { focus = false } = {}) {
        const filter = tab.dataset.reviewFilter || "";
        const key = tab.dataset.reviewFilterKey === "country" ? "reviewCountry" : "reviewProduct";

        tabs.forEach((button) => {
          const isActive = button === tab;
          button.classList.toggle("is-active", isActive);
          button.setAttribute("aria-selected", String(isActive));
          button.tabIndex = isActive ? 0 : -1;
        });

        reviews.forEach((review) => {
          review.hidden = review.dataset[key] !== filter;
        });
        list.setAttribute("aria-labelledby", tab.id);
        list.scrollTop = 0;
        if (focus) tab.focus();
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => activate(tab));
        tab.addEventListener("keydown", (event) => {
          if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === "ArrowRight") nextIndex = (index + 1) % tabs.length;
          if (event.key === "Home") nextIndex = 0;
          if (event.key === "End") nextIndex = tabs.length - 1;
          activate(tabs[nextIndex], { focus: true });
        });
      });

      activate(tabs.find((tab) => tab.classList.contains("is-active")) || tabs[0]);
    });
  }

  function setupReviewSummaries() {
    const buttons = Array.from(document.querySelectorAll("[data-review-summary]"));
    const panel = document.querySelector("[data-review-panel]");
    const views = Array.from(panel?.querySelectorAll("[data-review-view]") || []);
    if (!buttons.length || !panel || !views.length) return;

    const status = document.createElement("p");
    status.className = "sr-only";
    status.setAttribute("aria-live", "polite");
    panel.append(status);

    function activate(button, { scroll = true } = {}) {
      const mode = button.dataset.reviewSummary || "all";
      const activeView = views.find((view) => view.dataset.reviewView === mode) || views[0];

      buttons.forEach((candidate) => {
        const isActive = candidate === button;
        candidate.setAttribute("aria-pressed", String(isActive));
        candidate.closest("article")?.classList.toggle("is-active", isActive);
      });

      views.forEach((view) => {
        const isActive = view === activeView;
        view.hidden = !isActive;
        view.classList.toggle("is-active", isActive);
      });

      const heading = activeView.querySelector("h2")?.textContent || "Reviews de clientes";
      const visibleCount = activeView.querySelectorAll("[data-review-list] article:not([hidden])").length;
      activeView.querySelector("[data-review-list]")?.scrollTo({ top: 0 });
      status.textContent = `${heading}: ${visibleCount} opiniones mostradas.`;

      if (scroll) {
        panel.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
          block: "start",
        });
      }
    }

    buttons.forEach((button) => button.addEventListener("click", () => activate(button)));
    activate(buttons.find((button) => button.getAttribute("aria-pressed") === "true") || buttons[0], { scroll: false });
  }

  function setupProductControls() {
    document.querySelectorAll("[data-product-group]").forEach((group) => {
      const track = group.querySelector("[data-product-track]");
      const previous = group.querySelector("[data-product-prev]");
      const next = group.querySelector("[data-product-next]");
      if (!track || !previous || !next) return;

      function rotate(direction) {
        const cards = Array.from(track.children);
        if (cards.length < 2) return;

        if (direction > 0) track.append(cards[0]);
        else track.prepend(cards[cards.length - 1]);

        track.classList.remove("is-shifting");
        window.requestAnimationFrame(() => track.classList.add("is-shifting"));
      }

      previous.addEventListener("click", () => rotate(-1));
      next.addEventListener("click", () => rotate(1));
    });
  }

  function initializeReviews() {
    setupReviewTabs();
    setupReviewSummaries();
    setupProductControls();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeReviews, { once: true });
  } else {
    initializeReviews();
  }
})();


/* js/product.js */
(() => {
  "use strict";

  const normalizeVariantName = (value) => {
    const normalized = String(value || "")
      .replace(/\+/g, " ")
      .trim()
      .toLocaleLowerCase("es")
      .replace(/\s+/g, " ");
    return normalized === "dessert brown" ? "desert brown" : normalized;
  };

  const externalPurchaseUrls = {
    carrier: {
      houndstooth: "https://www.amazon.es/dp/B0FCWTT4HP",
      "desert brown": "https://www.amazon.es/dp/B0FCWWMS73",
      "maya blue": "https://www.amazon.es/dp/B0FCWBZGSX",
    },
    wrap: {
      "pebble gray": "https://www.amazon.es/dp/B0FC9Z4GHT",
      "midnight black": "https://www.amazon.es/dp/B0FC9RWRNH",
      "white bubble": "https://www.amazon.es/dp/B0FC9R1F24",
      "pistachio green": "https://www.amazon.es/dp/B0FCB5S7X2",
    },
  };
  const pathLocale = window.location.pathname.split("/").filter(Boolean)[0]?.toLowerCase();
  const documentLocale = String(document.documentElement.lang || "").toLowerCase();
  const shopifyLocale = String(window.Shopify?.locale || "").toLowerCase();
  const pageLocale = pathLocale === "en" || pathLocale === "es"
    ? pathLocale
    : documentLocale.startsWith("en") || documentLocale.startsWith("es")
      ? documentLocale
      : shopifyLocale || "es";
  const externalPurchaseCopy = pageLocale.startsWith("en")
    ? {
      label: (color) => `Buy ${color} on Amazon`,
      note: "Your purchase will be completed on Amazon.es.",
    }
    : {
      label: (color) => `Comprar ${color} en Amazon`,
      note: "La compra se completa en Amazon.es.",
    };

  const updateProductTitle = (variant) => {
    const title = document.querySelector("[data-product-title]");
    const variantLabel = title?.querySelector("[data-product-title-variant]");
    if (variantLabel && variant) variantLabel.textContent = variant;
  };

  const selectedProductColor = () =>
    document.querySelector("[data-product-option].is-active")?.getAttribute("aria-label") || "";

  const galleryOrientation = (aspectRatio) => {
    const ratio = Number(aspectRatio);
    if (!Number.isFinite(ratio) || ratio <= 0) return "";
    if (ratio >= 1.1) return "landscape";
    if (ratio <= 0.9) return "portrait";
    return "square";
  };

  const liveVariantAvailable = (color) => {
    const cartButton = document.querySelector(".purchase-card [data-cart-add]");
    const productName = cartButton?.dataset.cartAdd?.toLowerCase() || "";
    const productKey = productName.includes("wrap") ? "wrap" : productName.includes("trendi") ? "carrier" : "";
    const availability = window.BABIINI_SHOPIFY_PRODUCTS?.[productKey]?.availableVariants;
    if (!availability || typeof availability !== "object") return null;

    const normalizedColor = normalizeVariantName(color);
    const match = Object.entries(availability).find(([label]) =>
      normalizeVariantName(label) === normalizedColor
    );
    return match ? Boolean(match[1]) : null;
  };

  const fallbackVariantAvailable = (color) => {
    const liveAvailability = liveVariantAvailable(color);
    if (liveAvailability !== null) return liveAvailability;

    const normalizedColor = normalizeVariantName(color);
    const option = [...document.querySelectorAll("[data-product-option]")].find((item) =>
      normalizeVariantName(item.getAttribute("aria-label")) === normalizedColor
    );
    return option?.dataset.fallbackAvailable !== "false";
  };

  const renderFallbackAvailability = () => {
    document.querySelectorAll("[data-product-option]").forEach((option) => {
      const unavailable = !fallbackVariantAvailable(option.getAttribute("aria-label"));
      option.classList.toggle("is-unavailable", unavailable);
      option.setAttribute("aria-disabled", String(unavailable));
      option.title = unavailable ? "Agotado — únete a la lista de espera" : "";
    });

    const selected = document.querySelector("[data-product-option].is-active");
    const card = selected?.closest(".purchase-card");
    const color = selected?.getAttribute("aria-label") || "";
    updatePurchaseAvailability(card, color, fallbackVariantAvailable(color));
  };

  const updatePurchaseAvailability = (card, color, available = true) => {
    if (!(card instanceof HTMLElement)) return;
    const cartButtons = [...card.querySelectorAll("[data-cart-add]")];
    const actions = card.querySelector(".purchase-card__actions");
    const waitlist = card.querySelector("[data-waitlist-form]");
    const externalPurchase = card.querySelector("[data-external-purchase]");
    const quantityLabel = card.querySelector(".purchase-card__quantity");
    const quantity = card.querySelector("[data-product-quantity]");
    const productName = cartButtons[0]?.dataset.cartAdd?.toLowerCase() || "";
    const productKey = productName.includes("wrap") ? "wrap" : productName.includes("trendi") ? "carrier" : "";
    const externalPurchaseUrl = available
      ? ""
      : externalPurchaseUrls[productKey]?.[normalizeVariantName(color)] || "";

    cartButtons.forEach((button) => {
      button.hidden = !available;
      button.disabled = !available;
    });
    if (actions instanceof HTMLElement) actions.hidden = !available;
    if (waitlist instanceof HTMLFormElement) {
      waitlist.hidden = available;
      waitlist.dataset.waitlistColor = color;
      waitlist.dataset.waitlistProduct = document.querySelector("#product-title")?.textContent?.trim() || "Producto Babiini";
    }
    if (externalPurchase instanceof HTMLElement) {
      externalPurchase.hidden = !externalPurchaseUrl;
      const link = externalPurchase.querySelector("[data-external-purchase-link]");
      const label = externalPurchase.querySelector("[data-external-purchase-label]");
      const note = externalPurchase.querySelector("[data-external-purchase-note]");
      if (link instanceof HTMLAnchorElement && externalPurchaseUrl) link.href = externalPurchaseUrl;
      if (label instanceof HTMLElement) label.textContent = externalPurchaseCopy.label(color);
      if (note instanceof HTMLElement) note.textContent = externalPurchaseCopy.note;
    }
    if (quantityLabel instanceof HTMLElement) quantityLabel.hidden = !available;
    if (quantity instanceof HTMLInputElement) {
      quantity.hidden = !available;
      quantity.disabled = !available;
    }
    card.dataset.variantAvailable = String(available);
  };

  const requestedColor = normalizeVariantName(
    document.documentElement.dataset.requestedProductColor ||
    new URLSearchParams(window.location.search).get("color") || "",
  );
  const requestedOption = requestedColor
    ? [...document.querySelectorAll("[data-product-option]")].find((option) =>
      normalizeVariantName(option.getAttribute("aria-label")) === requestedColor
    )
    : null;

  if (requestedOption) {
    const group = requestedOption.closest(".purchase-options__swatches");
    group?.querySelectorAll("[data-product-option]").forEach((item) => {
      item.classList.toggle("is-active", item === requestedOption);
    });
    const color = requestedOption.getAttribute("aria-label") || "";
    requestedOption.closest(".purchase-card")?.querySelectorAll("[data-cart-add]").forEach((button) => {
      button.dataset.cartColor = color;
    });
  }

  updateProductTitle(selectedProductColor());

  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const image = gallery.querySelector("[data-gallery-main]");
    const source = gallery.querySelector("[data-gallery-source]");
    const thumbsRoot = gallery.querySelector(".product-gallery__thumbs");
    const handle = gallery.dataset.productHandle;
    const fallbackThumbs = [...gallery.querySelectorAll("[data-gallery-thumb]")].map((thumb) => thumb.cloneNode(true));
    const fallbackImage = {
      src: image?.getAttribute("src") || "",
      mobile: source?.getAttribute("srcset") || "",
      fit: image?.dataset.galleryFit || "cover",
      alt: image?.getAttribute("alt") || "",
    };
    let mediaByVariant = new Map();

    if (!image || !thumbsRoot || !fallbackThumbs.length) {
      document.documentElement.classList.remove("product-variant-pending");
      return;
    }

    const syncImageOrientation = () => {
      const orientation = galleryOrientation(image.naturalWidth / image.naturalHeight);
      if (orientation) image.dataset.galleryOrientation = orientation;
    };
    image.addEventListener("load", syncImageOrientation);
    if (image.complete && image.naturalWidth > 0) syncImageOrientation();

    if (requestedColor) gallery.setAttribute("aria-busy", "true");

    let initialVariantReady = false;
    const finishInitialVariant = () => {
      if (initialVariantReady) return;
      initialVariantReady = true;
      gallery.removeAttribute("aria-busy");
      document.documentElement.classList.remove("product-variant-pending");
    };

    const revealWhenImageReady = () => {
      if (!requestedColor) return;
      const finish = () => finishInitialVariant();
      window.requestAnimationFrame(() => {
        if (image.complete && image.naturalWidth > 0) {
          if (typeof image.decode === "function") image.decode().catch(() => {}).finally(finish);
          else finish();
          return;
        }
        image.addEventListener("load", finish, { once: true });
        image.addEventListener("error", finish, { once: true });
        window.setTimeout(finish, 3000);
      });
    };

    const selectThumb = (thumb) => {
      const thumbs = [...thumbsRoot.querySelectorAll("[data-gallery-thumb]")];
      thumbs.forEach((item) => item.classList.toggle("is-active", item === thumb));
      image.src = thumb.dataset.gallerySrc || image.src;
      if (source) source.srcset = thumb.dataset.galleryMobile || thumb.dataset.gallerySrc || image.src;
      image.dataset.galleryFit = thumb.dataset.galleryFit || "contain";
      if (thumb.dataset.galleryOrientation) image.dataset.galleryOrientation = thumb.dataset.galleryOrientation;
    };

    thumbsRoot.addEventListener("click", (event) => {
      const thumb = event.target instanceof Element ? event.target.closest("[data-gallery-thumb]") : null;
      if (thumb) selectThumb(thumb);
    });

    const updateCartImage = (src) => {
      document.querySelectorAll(".purchase-card [data-cart-add]").forEach((button) => {
        button.dataset.cartImage = src;
      });
    };

    const restoreFallback = () => {
      thumbsRoot.replaceChildren(...fallbackThumbs.map((thumb) => thumb.cloneNode(true)));
      thumbsRoot.scrollTop = 0;
      image.src = fallbackImage.src;
      image.alt = fallbackImage.alt;
      image.dataset.galleryFit = fallbackImage.fit;
      if (source) source.srcset = fallbackImage.mobile || fallbackImage.src;
      gallery.dataset.gallerySource = "local";
      delete gallery.dataset.galleryVariant;
      updateCartImage(fallbackImage.src);
      renderFallbackAvailability();
      revealWhenImageReady();
    };

    const renderVariant = (color) => {
      const variant = mediaByVariant.get(normalizeVariantName(color));
      const available = fallbackVariantAvailable(color) && (!variant || variant.available !== false);
      updatePurchaseAvailability(gallery.closest(".product-intro__inner")?.querySelector(".purchase-card"), color, available);
      if (!variant?.media.length) {
        restoreFallback();
        return;
      }

      const fragment = document.createDocumentFragment();
      variant.media.forEach((media, index) => {
        const thumb = document.createElement("button");
        thumb.type = "button";
        thumb.className = index === 0 ? "is-active" : "";
        thumb.setAttribute("aria-label", `Ver imagen ${index + 1} de ${variant.media.length} — ${variant.title}`);
        thumb.dataset.galleryThumb = "";
        thumb.dataset.gallerySrc = media.src;
        thumb.dataset.galleryMobile = media.src;
        thumb.dataset.galleryFit = "contain";
        thumb.dataset.galleryOrientation = media.orientation;

        const preview = document.createElement("img");
        preview.src = media.src;
        preview.width = 88;
        preview.height = 88;
        preview.loading = index > 4 ? "lazy" : "eager";
        preview.alt = "";
        thumb.append(preview);
        fragment.append(thumb);
      });

      thumbsRoot.replaceChildren(fragment);
      thumbsRoot.scrollTop = 0;
      image.src = variant.media[0].src;
      image.alt = `${variant.productTitle} — ${variant.title}`;
      image.dataset.galleryFit = "contain";
      image.dataset.galleryOrientation = variant.media[0].orientation;
      if (source) source.srcset = variant.media[0].src;
      gallery.dataset.gallerySource = "shopify";
      gallery.dataset.galleryVariant = variant.title;
      updateCartImage(variant.media[0].src);
      revealWhenImageReady();
    };

    document.addEventListener("babiini:productvariantchange", (event) => {
      renderVariant(event.detail?.color || "");
    });

    if (!handle) return;

    fetch(`/products/${encodeURIComponent(handle)}.js?inventory=${Date.now()}`, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      cache: "no-store",
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Product media request failed with ${response.status}`);
        return response.json();
      })
      .then((product) => {
        const media = Array.isArray(product.media)
          ? product.media
            .filter((item) => item?.media_type === "image" && (item.src || item.preview_image?.src))
            .map((item) => ({
              position: Number(item.position) || 0,
              src: item.src || item.preview_image.src,
              orientation: galleryOrientation(
                item.aspect_ratio ||
                Number(item.width || item.preview_image?.width) / Number(item.height || item.preview_image?.height),
              ),
            }))
            .sort((a, b) => a.position - b.position)
          : [];
        const variants = Array.isArray(product.variants)
          ? product.variants
            .filter((variant) => Number(variant?.featured_image?.position) > 0)
            .sort((a, b) => a.featured_image.position - b.featured_image.position)
          : [];

        mediaByVariant = new Map(variants.map((variant, index) => {
          const start = Number(variant.featured_image.position);
          const end = Number(variants[index + 1]?.featured_image?.position) || Number.POSITIVE_INFINITY;
          return [
            normalizeVariantName(variant.title),
            {
              title: variant.title,
              productTitle: product.title || "Producto Babiini",
              available: variant.available !== false,
              media: media.filter((item) => item.position >= start && item.position < end),
            },
          ];
        }));

        document.querySelectorAll("[data-product-option]").forEach((option) => {
          const variant = mediaByVariant.get(normalizeVariantName(option.getAttribute("aria-label")));
          const unavailable = !fallbackVariantAvailable(option.getAttribute("aria-label")) || variant?.available === false;
          option.classList.toggle("is-unavailable", unavailable);
          option.setAttribute("aria-disabled", String(unavailable));
          option.title = unavailable ? "Agotado — únete a la lista de espera" : "";
        });

        renderVariant(selectedProductColor());
      })
      .catch(() => {
        restoreFallback();
      });
  });

  renderFallbackAvailability();
  document.addEventListener("babiini:availabilitychange", renderFallbackAvailability);

  document.querySelectorAll("[data-external-purchase-link]").forEach((link) => {
    link.addEventListener("click", () => {
      if (!(link instanceof HTMLAnchorElement)) return;
      const cartButton = link.closest(".purchase-card")?.querySelector("[data-cart-add]");
      const destination = new URL(link.href);
      const eventData = {
        destination: "amazon_es",
        link_domain: destination.hostname,
        link_url: destination.href,
        product_id: cartButton?.dataset.cartAdd || "",
        product_name: cartButton?.dataset.cartName || "",
        product_variant: selectedProductColor(),
      };

      if (typeof window.gtag === "function") {
        window.gtag("event", "amazon_outbound_click", eventData);
      }
      if (typeof window.Shopify?.analytics?.publish === "function") {
        window.Shopify.analytics.publish("babiini:amazon_outbound_click", eventData);
      }
    });
  });

  document.querySelectorAll("[data-product-option]").forEach((option) => {
    option.addEventListener("click", () => {
      const group = option.closest(".purchase-options__swatches");
      group?.querySelectorAll("[data-product-option]").forEach((item) => item.classList.toggle("is-active", item === option));
      const card = option.closest(".purchase-card");
      const color = option.getAttribute("aria-label") || "";
      updateProductTitle(color);
      card?.querySelectorAll("[data-cart-add]").forEach((button) => {
        button.dataset.cartColor = color;
      });

      const url = new URL(window.location.href);
      url.searchParams.set("color", color);
      window.history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`);
      document.dispatchEvent(new CustomEvent("babiini:productvariantchange", { detail: { color } }));
      const cartButton = card?.querySelector("[data-cart-add]");
      const rawProductKey = cartButton?.dataset.cartAdd?.toLowerCase() || "";
      const productKey = rawProductKey.includes("pack") ? "pack" : rawProductKey.includes("wrap") ? "wrap" : "carrier";
      const productData = window.BABIINI_SHOPIFY_PRODUCTS?.[productKey];
      const variantId = productData?.variants?.[color];
      const variantPrice = parseFloat(cartButton?.dataset.cartPrice) || productData?.price;
      if (variantId && typeof fbq === "function") {
        fbq("track", "ViewContent", {
          content_ids: [variantId],
          content_type: "product",
          value: variantPrice,
          currency: "EUR",
        });
      }
    });
  });

  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const image = gallery.querySelector("[data-gallery-main]");
    if (!(image instanceof HTMLImageElement)) return;

    const dialog = document.createElement("dialog");
    dialog.className = "product-lightbox";
    dialog.setAttribute("aria-label", "Vista ampliada del producto");
    dialog.innerHTML = `
      <div class="product-lightbox__panel">
        <button class="product-lightbox__close" type="button" aria-label="Cerrar vista ampliada">×</button>
        <div class="product-lightbox__viewport"><img class="product-lightbox__image" alt=""></div>
        <div class="product-lightbox__controls" aria-label="Controles de zoom">
          <button type="button" aria-label="Alejar" data-lightbox-zoom="out">−</button>
          <button type="button" aria-label="Restablecer zoom" data-lightbox-zoom="reset">1:1</button>
          <button type="button" aria-label="Acercar" data-lightbox-zoom="in">+</button>
        </div>
      </div>`;
    document.body.append(dialog);

    const enlarged = dialog.querySelector(".product-lightbox__image");
    let scale = 1;
    const renderScale = () => enlarged?.style.setProperty("--lightbox-scale", String(scale));
    const openLightbox = () => {
      if (!(enlarged instanceof HTMLImageElement)) return;
      enlarged.src = image.currentSrc || image.src;
      enlarged.alt = image.alt;
      scale = 1;
      renderScale();
      dialog.showModal();
      dialog.querySelector(".product-lightbox__close")?.focus();
    };

    image.setAttribute("role", "button");
    image.tabIndex = 0;
    image.setAttribute("aria-label", `${image.alt}. Abrir vista ampliada`);
    image.addEventListener("click", openLightbox);
    image.addEventListener("keydown", (event) => {
      if (!['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      openLightbox();
    });
    dialog.querySelector(".product-lightbox__close")?.addEventListener("click", () => dialog.close());
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.querySelectorAll("[data-lightbox-zoom]").forEach((button) => {
      button.addEventListener("click", () => {
        if (button.dataset.lightboxZoom === "in") scale = Math.min(3, scale + 0.5);
        if (button.dataset.lightboxZoom === "out") scale = Math.max(1, scale - 0.5);
        if (button.dataset.lightboxZoom === "reset") scale = 1;
        renderScale();
      });
    });
  });

  document.querySelectorAll("[data-waitlist-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!(form instanceof HTMLFormElement)) return;
      const status = form.querySelector("[data-waitlist-status]");
      if (!(status instanceof HTMLElement)) return;
      const data = new FormData(form);
      const email = String(data.get("email") || "").trim();
      if (!email) {
        status.textContent = "Introduce tu correo electrónico.";
        return;
      }

      const selectedProduct = form.dataset.waitlistProduct || "Producto Babiini";
      const selectedColor = form.dataset.waitlistColor || "";

      const submit = form.querySelector("button[type='submit']");
      if (submit instanceof HTMLButtonElement) submit.disabled = true;
      status.textContent = "Enviando…";
      const payload = new URLSearchParams({
        form_type: "contact",
        utf8: "✓",
        "contact[email]": email,
        "contact[body]": `Lista de espera: ${selectedProduct} — ${selectedColor}`,
        "contact[tags]": "waitlist,product-waitlist",
      });

      try {
        const response = await fetch("/contact", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
          body: payload,
        });
        if (!response.ok) throw new Error("Waitlist request failed");
        form.reset();
        status.textContent = "Listo. Te avisaremos cuando este diseño vuelva a estar disponible.";
      } catch (_error) {
        status.textContent = "No pudimos guardar tu solicitud. Inténtalo de nuevo.";
      } finally {
        if (submit instanceof HTMLButtonElement) submit.disabled = false;
      }
    });
  });

  document.querySelectorAll("[data-detail-target]").forEach((button) => {
    button.addEventListener("click", () => {
      const details = button.closest(".product-details");
      details?.querySelectorAll("[data-detail-target]").forEach((item) => item.classList.toggle("is-active", item === button));
      const target = details?.querySelector(`[data-detail-section="${button.dataset.detailTarget}"]`);
      if (target instanceof HTMLDetailsElement) target.open = true;
      target?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  });

  const quickGuides = {
    wrap: {
      title: "Porteo delantero con fular",
      steps: [
        "Extiende el fular y localiza su punto central.",
        "Coloca el centro sobre el pecho y cruza los extremos por la espalda.",
        "Forma las bandas de soporte, introduce al bebé y confirma una posición M segura.",
        "Ajusta la tela de hombro a hombro y comprueba que la vía respiratoria esté despejada.",
      ],
    },
    carrier: {
      title: "Portabebés con bebé mirando hacia adentro",
      steps: [
        "Ajusta el cinturón a tu cintura y cierra la hebilla de seguridad.",
        "Sienta al bebé frente a ti, con las rodillas más altas que el culete.",
        "Sube el panel, coloca los tirantes y ajusta ambos lados de forma uniforme.",
        "Comprueba que el bebé esté visible, lo bastante cerca para besar y con la espalda sostenida.",
      ],
    },
  };

  const guideOpeners = document.querySelectorAll("[data-quick-guide-open]");
  if (guideOpeners.length) {
    const guideDialog = document.createElement("dialog");
    guideDialog.className = "quick-guide-dialog";
    guideDialog.setAttribute("aria-labelledby", "quick-guide-title");

    const panel = document.createElement("div");
    panel.className = "quick-guide-dialog__panel";
    const close = document.createElement("button");
    close.className = "quick-guide-dialog__close";
    close.type = "button";
    close.setAttribute("aria-label", "Cerrar guía rápida");
    close.textContent = "×";
    const eyebrow = document.createElement("p");
    eyebrow.className = "quick-guide-dialog__eyebrow";
    eyebrow.textContent = "Guía rápida";
    const title = document.createElement("h2");
    title.id = "quick-guide-title";
    const steps = document.createElement("ol");
    const understood = document.createElement("button");
    understood.className = "button button--primary";
    understood.type = "button";
    understood.textContent = "Entendido";
    panel.append(close, eyebrow, title, steps, understood);
    guideDialog.append(panel);
    document.body.append(guideDialog);

    const closeGuide = () => guideDialog.close();
    close.addEventListener("click", closeGuide);
    understood.addEventListener("click", closeGuide);
    guideDialog.addEventListener("click", (event) => {
      if (event.target === guideDialog) closeGuide();
    });

    guideOpeners.forEach((button) => {
      button.addEventListener("click", () => {
        const guide = quickGuides[button.dataset.quickGuideOpen];
        if (!guide) return;
        title.textContent = guide.title;
        steps.replaceChildren(...guide.steps.map((step) => {
          const item = document.createElement("li");
          item.textContent = step;
          return item;
        }));
        guideDialog.showModal();
        close.focus();
      });
    });
  }

  document.querySelectorAll("[data-product-testimonials]").forEach((root) => {
    const track = root.querySelector("[data-product-testimonial-track]");
    const previous = root.querySelector("[data-product-testimonial-prev]");
    const next = root.querySelector("[data-product-testimonial-next]");
    const status = root.querySelector("[data-product-testimonial-status]");
    if (!track || !previous || !next) return;

    const visibleCount = () => window.innerWidth < 768 ? 1 : window.innerWidth < 992 ? 2 : 3;
    const render = (announce = false) => {
      const cards = [...track.children];
      cards.forEach((card, index) => {
        const visible = index < visibleCount();
        card.hidden = !visible;
        card.setAttribute("aria-hidden", String(!visible));
      });
      if (announce && status) status.textContent = `Mostrando ${cards[0]?.querySelector("h3")?.textContent || "testimonio"}`;
    };
    const move = (direction) => {
      const cards = [...track.children];
      if (direction > 0) track.append(cards[0]);
      else track.prepend(cards[cards.length - 1]);
      render(true);
    };
    previous.addEventListener("click", () => move(-1));
    next.addEventListener("click", () => move(1));
    let start = null;
    track.addEventListener("pointerdown", (event) => { if (event.isPrimary) start = event.clientX; });
    track.addEventListener("pointerup", (event) => {
      if (start === null) return;
      const delta = event.clientX - start;
      start = null;
      if (Math.abs(delta) > 35) move(delta < 0 ? 1 : -1);
    });
    window.addEventListener("resize", () => render());
    render();
  });

  document.querySelectorAll("[data-feature-carousel]").forEach((carousel) => {
    const image = carousel.querySelector("[data-feature-image]");
    const mobile = carousel.querySelector("[data-feature-mobile]");
    const tablet = carousel.querySelector("[data-feature-tablet]");
    const dots = [...carousel.querySelectorAll("[data-feature-dot]")];
    const previous = carousel.querySelector("[data-feature-prev]");
    const next = carousel.querySelector("[data-feature-next]");
    const status = carousel.querySelector("[data-feature-status]");
    const path = carousel.dataset.featurePath;
    if (!image || !path || !dots.length) return;

    let currentIndex = 0;
    let autoplayTimer = null;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let pointerId = null;
    let pointerStart = 0;
    let pointerCurrent = 0;
    let pointerLink = null;
    let suppressClick = false;
    let wheelDistance = 0;
    let wheelDirection = 0;
    let wheelGestureLocked = false;
    let wheelReset = 0;

    const render = (index, announce = false) => {
      currentIndex = (index + dots.length) % dots.length;
      const key = dots[currentIndex].dataset.featureDot;
      dots.forEach((item, dotIndex) => {
        const active = dotIndex === currentIndex;
        item.classList.toggle("is-active", active);
        item.setAttribute("aria-current", String(active));
      });
      image.src = window.babiiniAssetUrl(`products/${path}/feature-${key}-desktop.jpg`);
      if (tablet) tablet.srcset = window.babiiniAssetUrl(`products/${path}/feature-${key}-tablet.avif`);
      if (mobile) mobile.srcset = window.babiiniAssetUrl(`products/${path}/feature-${key}-mobile.avif`);
      if (announce && status) status.textContent = `Característica ${currentIndex + 1} de ${dots.length}`;
    };

    const stopAutoplay = () => {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!reduceMotion && !document.hidden) {
        autoplayTimer = window.setInterval(() => render(currentIndex + 1), 5500);
      }
    };

    const move = (direction) => {
      render(currentIndex + direction, true);
      startAutoplay();
    };

    dots.forEach((dot, index) => dot.addEventListener("click", () => {
      render(index, true);
      startAutoplay();
    }));
    previous?.addEventListener("click", () => move(-1));
    next?.addEventListener("click", () => move(1));

    carousel.style.touchAction = "pan-y";
    carousel.addEventListener("dragstart", (event) => event.preventDefault());
    carousel.addEventListener("pointerdown", (event) => {
      if (!event.isPrimary || (event.pointerType === "mouse" && event.button !== 0)) return;
      if (
        event.target instanceof Element &&
        event.target.closest("button, input, select, textarea, [role='button']")
      ) {
        return;
      }
      pointerId = event.pointerId;
      pointerStart = event.clientX;
      pointerCurrent = pointerStart;
      pointerLink =
        event.target.closest("a[href]") ||
        event.target.closest(".is-product-link")?.querySelector("a[href]") ||
        null;
    });
    carousel.addEventListener("pointermove", (event) => {
      if (pointerId !== event.pointerId) return;
      pointerCurrent = event.clientX;
      if (Math.abs(pointerCurrent - pointerStart) >= 54 && !carousel.hasPointerCapture?.(pointerId)) {
        carousel.setPointerCapture?.(pointerId);
      }
    });

    const finishSwipe = (event) => {
      if (pointerId !== event.pointerId) return;
      const distance = pointerCurrent - pointerStart;
      const clickLink = pointerLink;
      if (carousel.hasPointerCapture?.(pointerId)) carousel.releasePointerCapture?.(pointerId);
      pointerId = null;
      pointerLink = null;

      if (Math.abs(distance) >= 54) {
        move(distance < 0 ? 1 : -1);
        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 0);
      } else if (Math.abs(distance) > 6 && clickLink instanceof HTMLAnchorElement) {
        window.setTimeout(() => clickLink.click(), 0);
      }
    };

    carousel.addEventListener("pointerup", finishSwipe);
    carousel.addEventListener("pointercancel", (event) => {
      if (pointerId !== event.pointerId) return;
      pointerId = null;
      pointerLink = null;
    });
    carousel.addEventListener(
      "click",
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true,
    );

    carousel.addEventListener(
      "wheel",
      (event) => {
        const horizontalGesture = Math.abs(event.deltaX) > Math.abs(event.deltaY) * 1.15;
        const shiftedGesture = event.shiftKey && Math.abs(event.deltaY) > 0;
        if (!horizontalGesture && !shiftedGesture) return;

        const rawDistance = horizontalGesture ? event.deltaX : event.deltaY;
        const deltaMultiplier = event.deltaMode === 1
          ? 16
          : event.deltaMode === 2
            ? carousel.clientWidth
            : 1;
        const distance = rawDistance * deltaMultiplier;
        if (!distance) return;

        event.preventDefault();
        window.clearTimeout(wheelReset);
        wheelReset = window.setTimeout(() => {
          wheelDistance = 0;
          wheelDirection = 0;
          wheelGestureLocked = false;
        }, 260);

        if (wheelGestureLocked) return;

        const direction = Math.sign(distance);
        if (wheelDirection && wheelDirection !== direction) {
          wheelDistance = 0;
        }
        wheelDirection = direction;
        wheelDistance += distance;

        if (Math.abs(wheelDistance) < 64) return;
        move(direction > 0 ? 1 : -1);
        wheelDistance = 0;
        wheelGestureLocked = true;
      },
      { passive: false },
    );

    carousel.addEventListener("pointerenter", stopAutoplay);
    carousel.addEventListener("pointerleave", startAutoplay);
    carousel.addEventListener("focusin", stopAutoplay);
    carousel.addEventListener("focusout", (event) => {
      if (!carousel.contains(event.relatedTarget)) startAutoplay();
    });
    document.addEventListener("visibilitychange", () => document.hidden ? stopAutoplay() : startAutoplay());
    render(0);
    startAutoplay();
  });

  document.querySelectorAll("[data-related-products]").forEach((root) => {
    const track = root.querySelector("[data-related-track]");
    const previous = root.querySelector("[data-related-prev]");
    const next = root.querySelector("[data-related-next]");
    if (!track || !previous || !next || track.children.length < 2) return;

    const move = (direction) => {
      if (direction > 0) track.append(track.firstElementChild);
      else track.prepend(track.lastElementChild);
    };

    previous.addEventListener("click", () => move(-1));
    next.addEventListener("click", () => move(1));

    let pointerId = null;
    let pointerStart = 0;
    let pointerCurrent = 0;
    let pointerLink = null;
    let suppressClick = false;
    let wheelDistance = 0;
    let wheelDirection = 0;
    let wheelGestureLocked = false;
    let wheelReset = 0;

    track.style.touchAction = "pan-y";
    track.addEventListener("dragstart", (event) => event.preventDefault());

    track.addEventListener("pointerdown", (event) => {
      if (!event.isPrimary || (event.pointerType === "mouse" && event.button !== 0)) return;
      if (
        event.target instanceof Element &&
        event.target.closest("button, input, select, textarea, [role='button']")
      ) {
        return;
      }
      pointerId = event.pointerId;
      pointerStart = event.clientX;
      pointerCurrent = pointerStart;
      pointerLink =
        event.target.closest("a[href]") ||
        event.target.closest(".is-product-link")?.querySelector("a[href]") ||
        null;
    });
    track.addEventListener("pointermove", (event) => {
      if (pointerId !== event.pointerId) return;
      pointerCurrent = event.clientX;
      if (Math.abs(pointerCurrent - pointerStart) >= 54 && !track.hasPointerCapture?.(pointerId)) {
        track.setPointerCapture?.(pointerId);
      }
    });

    const finishSwipe = (event) => {
      if (pointerId !== event.pointerId) return;
      const distance = pointerCurrent - pointerStart;
      const clickLink = pointerLink;
      if (track.hasPointerCapture?.(pointerId)) track.releasePointerCapture?.(pointerId);
      pointerId = null;
      pointerLink = null;

      if (Math.abs(distance) >= 54) {
        move(distance < 0 ? 1 : -1);
        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 0);
      } else if (Math.abs(distance) > 6 && clickLink instanceof HTMLAnchorElement) {
        window.setTimeout(() => clickLink.click(), 0);
      }
    };

    track.addEventListener("pointerup", finishSwipe);
    track.addEventListener("pointercancel", (event) => {
      if (pointerId !== event.pointerId) return;
      pointerId = null;
      pointerLink = null;
    });
    track.addEventListener(
      "click",
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true,
    );

    track.addEventListener(
      "wheel",
      (event) => {
        const horizontalGesture = Math.abs(event.deltaX) > Math.abs(event.deltaY) * 1.15;
        const shiftedGesture = event.shiftKey && Math.abs(event.deltaY) > 0;
        if (!horizontalGesture && !shiftedGesture) return;

        const rawDistance = horizontalGesture ? event.deltaX : event.deltaY;
        const deltaMultiplier = event.deltaMode === 1
          ? 16
          : event.deltaMode === 2
            ? root.clientWidth
            : 1;
        const distance = rawDistance * deltaMultiplier;
        if (!distance) return;

        event.preventDefault();
        window.clearTimeout(wheelReset);
        wheelReset = window.setTimeout(() => {
          wheelDistance = 0;
          wheelDirection = 0;
          wheelGestureLocked = false;
        }, 260);

        if (wheelGestureLocked) return;

        const direction = Math.sign(distance);
        if (wheelDirection && wheelDirection !== direction) {
          wheelDistance = 0;
        }
        wheelDirection = direction;
        wheelDistance += distance;

        if (Math.abs(wheelDistance) < 64) return;
        move(direction > 0 ? 1 : -1);
        wheelDistance = 0;
        wheelGestureLocked = true;
      },
      { passive: false },
    );
  });
})();


/* js/tutorials.js */
(() => {
  "use strict";

  const playerRoots = [...document.querySelectorAll("[data-vimeo-player]")];
  if (!playerRoots.length) return;

  let sdkPromise;

  const formatTime = (seconds) => {
    const safeSeconds = Number.isFinite(seconds) ? Math.max(0, Math.round(seconds)) : 0;
    const minutes = Math.floor(safeSeconds / 60);
    const remainingSeconds = String(safeSeconds % 60).padStart(2, "0");
    return `${minutes}:${remainingSeconds}`;
  };

  const loadVimeoSdk = () => {
    if (window.Vimeo?.Player) return Promise.resolve(window.Vimeo);
    if (sdkPromise) return sdkPromise;

    sdkPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector("script[data-vimeo-sdk]");
      const handleLoad = () => window.Vimeo?.Player
        ? resolve(window.Vimeo)
        : reject(new Error("La API de Vimeo no está disponible."));

      if (existingScript) {
        existingScript.addEventListener("load", handleLoad, { once: true });
        existingScript.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = "https://player.vimeo.com/api/player.js";
      script.async = true;
      script.dataset.vimeoSdk = "";
      script.addEventListener("load", handleLoad, { once: true });
      script.addEventListener("error", reject, { once: true });
      document.head.append(script);
    });

    return sdkPromise;
  };

  const setupPlayer = (root) => {
    const iframe = root.querySelector("[data-vimeo-frame]");
    const toggle = root.querySelector("[data-vimeo-toggle]");
    const toggleIcon = toggle?.querySelector("span");
    const progress = root.querySelector("[data-vimeo-progress]");
    const status = root.querySelector("[data-vimeo-status]");
    const endScreen = root.querySelector("[data-vimeo-end-screen]");
    const replay = root.querySelector("[data-vimeo-replay]");
    if (!iframe || !toggle || !toggleIcon || !progress || !endScreen || !replay) return;

    const sourceValue = root.dataset.vimeoSrc;
    if (!sourceValue) return;

    let player = null;
    let duration = 0;
    let isSeeking = false;
    let state = "idle";

    const source = new URL(sourceValue, window.location.href);
    const videoId = source.pathname.split("/").filter(Boolean).pop();
    const hash = source.searchParams.get("h");
    const publicUrl = videoId
      ? `https://vimeo.com/${videoId}${hash ? `/${hash}` : ""}`
      : "https://vimeo.com/";

    const showPlayState = (isPlaying) => {
      if (isPlaying) {
        root.classList.remove("is-ended");
        endScreen.hidden = true;
      }
      toggleIcon.textContent = isPlaying ? "❚❚" : "▶";
      toggle.setAttribute("aria-label", isPlaying ? "Pausar video" : "Reproducir video");
      root.classList.toggle("is-playing", isPlaying);
      if (status) status.textContent = isPlaying ? "Video en reproducción" : "Video en pausa";
    };

    const showEndedState = () => {
      showPlayState(false);
      progress.value = "100";
      updateProgressLabel(duration);
      root.classList.add("is-ended");
      endScreen.hidden = false;
      if (status) status.textContent = "El video terminó. Puedes reproducirlo de nuevo.";
    };

    const updateProgressLabel = (seconds) => {
      progress.setAttribute("aria-valuetext", `${formatTime(seconds)} de ${formatTime(duration)}`);
    };

    const showFallback = () => {
      state = "error";
      player = null;
      iframe.hidden = true;
      iframe.removeAttribute("src");
      root.classList.remove("is-ready", "is-loading", "is-playing", "is-ended");
      root.classList.add("is-error");
      endScreen.hidden = true;
      toggleIcon.textContent = "Abrir en Vimeo ↗";
      toggle.setAttribute("aria-label", "Abrir el tutorial en Vimeo");
      if (status) status.textContent = "El reproductor no pudo cargarse. Puedes abrir el tutorial en Vimeo.";
    };

    const connect = async () => {
      if (state === "loading" || state === "ready") return;
      state = "loading";
      root.classList.add("is-loading");
      root.classList.remove("is-error");
      toggleIcon.textContent = "…";
      toggle.setAttribute("aria-label", "Cargando video");

      try {
        source.searchParams.set("autoplay", "1");
        source.searchParams.set("playsinline", "1");
        iframe.src = source.toString();
        iframe.hidden = false;

        const Vimeo = await loadVimeoSdk();
        player = new Vimeo.Player(iframe);
        const readyTimeout = new Promise((_, reject) => {
          window.setTimeout(() => reject(new Error("Vimeo tardó demasiado en responder.")), 8000);
        });
        duration = await Promise.race([
          player.ready().then(() => player.getDuration()),
          readyTimeout,
        ]);

        state = "ready";
        root.classList.remove("is-loading");
        root.classList.add("is-ready");
        updateProgressLabel(0);

        player.on("play", () => showPlayState(true));
        player.on("pause", () => {
          if (!root.classList.contains("is-ended")) showPlayState(false);
        });
        player.on("ended", showEndedState);
        player.on("timeupdate", (data) => {
          duration = data.duration || duration;
          if (!isSeeking && duration) progress.value = String((data.seconds / duration) * 100);
          updateProgressLabel(data.seconds);
        });

        try {
          await player.play();
        } catch (_error) {
          showPlayState(false);
        }
      } catch (_error) {
        showFallback();
      }
    };

    toggle.addEventListener("click", async () => {
      if (state === "error") {
        window.open(publicUrl, "_blank", "noopener,noreferrer");
        return;
      }
      if (state === "idle") {
        await connect();
        return;
      }
      if (!player || state !== "ready") return;
      try {
        const isPaused = await player.getPaused();
        if (isPaused) await player.play();
        else await player.pause();
      } catch (_error) {
        showFallback();
      }
    });

    replay.addEventListener("click", async () => {
      if (!player || state !== "ready") return;
      try {
        root.classList.remove("is-ended");
        endScreen.hidden = true;
        progress.value = "0";
        updateProgressLabel(0);
        await player.setCurrentTime(0);
        await player.play();
      } catch (_error) {
        showFallback();
      }
    });

    progress.addEventListener("pointerdown", () => {
      isSeeking = true;
    });
    progress.addEventListener("input", () => {
      if (!duration) return;
      updateProgressLabel((Number(progress.value) / 100) * duration);
    });
    progress.addEventListener("change", async () => {
      try {
        if (duration) await player.setCurrentTime((Number(progress.value) / 100) * duration);
      } catch (_error) {
        showFallback();
      } finally {
        isSeeking = false;
      }
    });
    progress.addEventListener("pointerup", () => {
      isSeeking = false;
    });
    progress.addEventListener("pointercancel", () => {
      isSeeking = false;
    });
    showPlayState(false);
  };

  playerRoots.forEach(setupPlayer);

})();


/* js/contact.js */
(() => {
  "use strict";

  const form = document.querySelector("[data-contact-form]");
  const status = form?.querySelector("[data-contact-status]");
  const success = form?.querySelector("[data-contact-success]");
  if (!form || !status || !success) return;

  const fields = [...form.querySelectorAll("input[required], textarea[required]")];
  const showSuccess = () => {
    form.querySelectorAll(".contact-form__field, .contact-form > .button").forEach((element) => {
      element.hidden = true;
    });
    status.hidden = true;
    success.hidden = false;
    success.focus({ preventScroll: true });
  };

  if (new URLSearchParams(window.location.search).get("contact_posted") === "true") showSuccess();

  fields.forEach((field) => {
    field.addEventListener("input", () => {
      field.removeAttribute("aria-invalid");
      status.hidden = true;
      status.textContent = "";
    });
  });

  form.addEventListener("submit", (event) => {
    fields.forEach((field) => {
      if (field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement) field.value = field.value.trim();
    });

    if (!form.checkValidity()) {
      event.preventDefault();
      fields.forEach((field) => field.setAttribute("aria-invalid", String(!field.checkValidity())));
      status.textContent = "Completa tu nombre, correo electrónico y mensaje.";
      status.hidden = false;
      form.querySelector(":invalid")?.focus();
      form.reportValidity();
      return;
    }

    if (!window.Shopify?.shop) {
      event.preventDefault();
      form.reset();
      showSuccess();
    }
  });
})();


/* js/meta-ads.js */
(() => {
  "use strict";

  const trustTrack = document.querySelector("[data-meta-trust-track]");
  const trustDots = Array.from(document.querySelectorAll("[data-meta-trust-dot]"));
  let trustIndex = 0;

  const showTrust = (index) => {
    if (!trustTrack || !trustDots.length) return;
    trustIndex = (index + trustDots.length) % trustDots.length;
    trustTrack.style.transform = `translateX(-${trustIndex * 33.3333}%)`;
    trustDots.forEach((dot, dotIndex) => {
      dot.classList.toggle("is-active", dotIndex === trustIndex);
      dot.setAttribute("aria-current", dotIndex === trustIndex ? "true" : "false");
    });
  };

  trustDots.forEach((dot) => {
    dot.addEventListener("click", () => showTrust(Number(dot.dataset.metaTrustDot)));
  });

  document.querySelectorAll(".meta-product-group").forEach((group) => {
    const track = group.querySelector("[data-meta-product-track]");
    const previous = group.querySelector("[data-meta-products-prev]");
    const next = group.querySelector("[data-meta-products-next]");
    if (!track || !previous || !next || track.children.length < 2) return;

    const move = (direction) => {
      if (direction > 0) track.append(track.firstElementChild);
      else track.prepend(track.lastElementChild);
    };

    previous.addEventListener("click", () => move(-1));
    next.addEventListener("click", () => move(1));

    let pointerStart = null;
    track.addEventListener("pointerdown", (event) => {
      if (event.isPrimary) pointerStart = event.clientX;
    });
    track.addEventListener("pointerup", (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) > 35) move(distance < 0 ? 1 : -1);
    });
    track.addEventListener("pointercancel", () => {
      pointerStart = null;
    });
  });

  const testimonialTrack = document.querySelector("[data-meta-testimonials-track]");
  const testimonials = testimonialTrack ? Array.from(testimonialTrack.children) : [];
  const testimonialStatus = document.querySelector("[data-meta-testimonial-status]");
  let testimonialIndex = 0;

  const showTestimonial = (index) => {
    if (!testimonials.length) return;
    testimonialIndex = (index + testimonials.length) % testimonials.length;
    testimonials.forEach((card, cardIndex) => {
      card.classList.toggle("is-active", cardIndex === testimonialIndex);
      card.classList.toggle("is-next", cardIndex === (testimonialIndex + 1) % testimonials.length);
    });
    if (testimonialStatus) testimonialStatus.textContent = `Testimonio ${testimonialIndex + 1} de ${testimonials.length}`;
  };

  document.querySelector("[data-meta-testimonial-prev]")?.addEventListener("click", () => showTestimonial(testimonialIndex - 1));
  document.querySelector("[data-meta-testimonial-next]")?.addEventListener("click", () => showTestimonial(testimonialIndex + 1));
  showTestimonial(0);
})();

